import {
  EventDispatcher
} from 'three';
import { fetcher } from './worldFetcher';
import { postitFetcher } from './postitFetcher';
import { SCENE_INTERACTION, SHOW_MODAL } from '../../constants/scene';
import { v4 as uuidv4 } from 'uuid';
import { getSceneDictionary, isUserInWorld, setScenesThatCanBeLocked, setModel } from './dataHelpers';
import { WEBRTC_EVENTS } from '../../constants/webrtc';
import { imageExists } from '../engine/helpers/api';
import { chatFetcher } from './chatFetcher';
import { generateImageWithThumbNormalCallbackAndCustomErrorCallback, getImgThumb, getLowResImageUrl, thumbImageWithNormalCallback } from '../engine/helpers/getImageType';
import CustomSelect from '../engine/helpers/customSelect';
import { SOCKET_EVENTS, userHistory, userProperties } from '../../socket/Socket';
import { DEVICE_SETTINGS } from './EVENTS/DeviceSettings';
import { CHAT_EVENTS, CHAT_EVENTS_OLD } from '../../constants/chat';
import { SCENE_EVENTS } from './EVENTS/ModelEvents';
export { SCENE_EVENTS };
import { MODEL_EVENTS } from './EVENTS/ModelEvents';
import { setmodel } from '../engine/helpers/buttonHelper';
import UserSelectorWithButton from '../Users/UserSelectorWithButton';
import { getUsersPreferedSettings, notificationSettings } from '../engine/data/globalState';
import { TRACK_EVENTS } from '../engine/constants/track';
import { TourStartForm } from "../TourMode/TourStartForm";
import { CONFIRM_NOTIFICATION_SIZE, CONFIRM_NOTIFICATION_THEME, CONFIRM_NOTIFICATION_TYPE } from "../Modals/Notifications/ConfirmNotification";
import { checkMediaPermissions, requestMediaPermissions } from "../engine/helpers/userMediaHelper";
import { SCENE_OBJECT_TYPES } from "../../constants/SceneObjects";
import { TourControlBar } from "../engine/TourModeWindow";
import { CallChatControls } from "../Controllers/OneOnOne/OneOnOneView";
import { DefaultControlMenu } from "../Navbar/Navbar";
import { OwnChairMenu, OwnVapiMenu } from "../Controllers/MeetingMode/MeetingModeView";
import OwnChessMenu from "../Navbar/OwnChessMenu";
import { checkUserFeature, FEATURE_NAMES } from "./rolesHelper";
import { isMobile } from '../engine/helpers/worldHelpers';
import { NOTIFICATION_EVENTS } from '../../constants/notifications';
export { MODEL_EVENTS };

const defaultWorld = { "version": 3, "scenes": [{ "id": uuidv4(), "name": "Default scene", "publicName": "Default scene", "startPositionX": null, "startPositionY": null, "background": { "type": "image", "mediumPath": "virtualRealityFiles/dreamstime.jpg", "sliceImage": true }, "objects": [], "ambientAudio": { "type": "audio" }, "introAudio": { "type": "audio" }, "sceneRotationY": 0, "backgroundRotationX": 0, "backgroundRotationY": 0, "backgroundRotationZ": 0, "autorotateAfterSeconds": 0, "autorotateSpeed": 0.1, "actionIfBackgroundVideoEnds": "stop", "goToSceneIdAfterBackgroundVideoEnds": "", "weather": null, "publicStage": false }], "rules": { "visibleIf": {}, "hiddenIf": {} }, "copyrightLogo": {}, "previewBackgroundImage": { "type": "image", "mediumPath": "virtualRealityFiles\/dreamstime_thumb.jpg", "transparent": false }, "socialMediaPreviewImage": {}, "worldAmbientAudio": {}, "customIcons": {}, "elementTypeIconAssignments": {}, "creatorUserIdOfWorld": "1", "publicAvailable": 1, "is_draft": 1 }
const worldsCanEnter = [];

const audioElement = document.querySelector('#audio-notification');

class Model extends EventDispatcher {
  constructor({ mode, CONFIG }) {
    super();
    setmodel(this);
    this.webRTCProps = {
      withAudio: false,
      withCamera: false,
    };
    setModel(this);

    /** @var {Scene3D|ModeView|ModeEdit|null} view **/
    this.view = null;

    /** @var {ChatPanel|null} chatPanel **/
    this.chatPanel = null;

    this.isMobile = isMobile();
    this.sceneData = {};
    this.editMode = mode === 'edit' ? true : false;
    this.pageMediaMuted = false;
    this.spectatorMode = !checkMediaPermissions();

    this.currentUserMood = 1;
    this.takenChairsByUsers = {};
    this.friends = { online: [], offline: [] };

    this.worldFetcher = fetcher;
    this.postitFetcher = postitFetcher;
    this.chatFetcher = chatFetcher;
    this.config = CONFIG;
    this.userData = null;
    this.tourData = {};

    this.iStream = { audio: true, video: true };
    this.iSitOnThisVRChair = null;
    this.myWebcamStreamId = null;
    this.userAvatarTexture = null;

    this.screenShareMuted = true;

    this.iShareScreen = false;
    this.iShareOnThisObj = null;

    this.lastPeerChairIClicked = null;
    this.lastScreenShareIClicked = null;

    if (localStorage.hasOwnProperty('soundDevice')) {
      this.sinkId = localStorage.getItem('soundDevice');
    } else {
      this.sinkId = 'default';
    }
    this.localTestStream = null;
    this.hideMediaDevices = true;
    this.requestAudioLevels;

    this.activeOneOnOneCall = false;
    this.oneOnOneCallView = null;
    this.activePreviewVideoModal = false;

    this.scenes = {};
    this.globalHistoryChat = null;

    this.userClicked = false;
    $(document).on('click touchend', () => { this.userClicked = true });

    this.socket = null;

    this.urlParams = new URLSearchParams(window.location.search);
    this.worldID = this.urlParams.get('id');
    this.roomLocation = this.urlParams.get('loc') || null;
    this.url = new URL(window.location.href);

    this.isAnimating = false;

    this.chatState = {
      expanded: false,
      chatComponentVisible: false,
      globalChatVisible: false,
      sceneChatVisible: false,
      oneOneOneChatVisible: false,
    }

    this.tourMode = false;
    this.guidedMode = false;
    this.tourContributore = false;
    this.isTourGuest = false;
    this.listInvitationTour = new Map();
    this.pendingTourInvitations = new Map();
    this.outgoingPodiumInvites = new Map();
    this.podiumInviteState = new Map();
    this.pendingOneToOne = false;
    this.hostingOneToOne = false;
    this.joiningOneToOnePodium = false;
    this.pendingPodiumGuest = null;
    this.oneToOneTourId = null;

    this.previewMode = false;
    this.publicStage = false;
    this.publicStreams = [];
    this.guestJoinedPublicStage = false;
    this.iPlayPublicStream = false;

    this.customSelect = new CustomSelect(this);

    this.showElements = true;
    this.friendsMap = {};
    this.userIsContributor = false;
    this.isFrozenSession = false;

    this.fetchedUserData = {};

    this.selectedVideoFromDropDown;
    this.selectedAudioFromDropDown;

    this.antMediaTrackMessages = [];

    this.clearEditorPublishDraft = () => {
      if (this.worldID) {
        localStorage.removeItem(`publish_${this.worldID}`);
      }
      localStorage.removeItem('last_edited_time');
    }

    this._editorDraftRestoreKey = () => `restoreEditorDraft_${this.worldID}`;

    this.markRestoreEditorDraft = () => {
      if (!this.worldID) return;
      try {
        sessionStorage.setItem(this._editorDraftRestoreKey(), '1');
      } catch (_) { /* private mode / quota */ }
    }

    this.consumeRestoreEditorDraft = () => {
      if (!this.worldID) return false;
      try {
        const key = this._editorDraftRestoreKey();
        const shouldRestore = sessionStorage.getItem(key) === '1';
        if (shouldRestore) sessionStorage.removeItem(key);
        return shouldRestore;
      } catch (_) {
        return false;
      }
    }

    this.parseEditorPublishDraft = (raw) => {
      if (!raw) return null;
      try {
        const parsed = JSON.parse(raw);
        return Array.isArray(parsed?.scenes) ? parsed : null;
      } catch (_) {
        return null;
      }
    }

    this.handlePreviewMode = () => {
      this.previewMode = this.urlParams.get('mode') === 'preview';

      const lastEditedTime = localStorage.getItem('last_edited_time');
      if (lastEditedTime) {
        const currentTimestamp = new Date().getTime();
        const elapsedTime = currentTimestamp - lastEditedTime;
        // Preview of unpublished edits is only valid for the current session (30 minutes).
        if (elapsedTime > 30 * 60 * 1000) {
          this.previewMode = false;
          localStorage.removeItem('last_edited_time');
        }
      } else {
        this.previewMode = false;
      }
    }

    this.handlePreviewMode();

    ///stream data
    ///stream data
    const newStreamUserWantsToShareAsScreenShare = null;
    this.getCameraHTMLObject = () => {
      if (!this.cameraHTMLobject) {
        this.cameraHTMLobject = document.getElementById('myVideo')
        // this.cameraHTMLobject = document.createElement('video');
      }
      return this.cameraHTMLobject;
    }
    this.getScreenShareHTMLObject = () => {
      if (!this.shareScreenHTMLobject) {
        this.shareScreenHTMLobject = document.getElementById('myVideoScreenShare')
        // this.shareScreenHTMLobject = document.createElement('video');
      }
      return this.shareScreenHTMLobject;
    }
    ///stream data END

    if (this.worldID) {
      this.worldFetcher.getContributores(this.worldID, (response) => {
        for (let x = 0; x < response.length; x++) {
          if (response[x].id === this.config.userId) {
            this.userIsContributor = true;
            break;
          }
        }
      }, (err) => { console.log(err) });
    }

    ///API
    this.getSceneData = (props) => {

      const { url } = props;
      const onSuccesCallback = (response) => {

        const responseData = response.data.hasOwnProperty('scenes') ? response.data : { ...defaultWorld, ...response.data };
        let scenesArray = responseData.scenes;
        for (let scene of scenesArray) {
          const rot = Number(scene.sceneRotationY);
          scene.sceneRotationY = Number.isFinite(rot) ? rot : 0;
        }

        const getLocalData = localStorage.getItem(`publish_${this.worldID}`);

        const dbSceneData = { ...responseData, scenes: scenesArray };
        const parsedDraft = this.parseEditorPublishDraft(getLocalData);
        const restoreEditorDraft = this.editMode && this.consumeRestoreEditorDraft();

        // Editor cold-open always uses the latest server version. Local drafts are only
        // restored for in-session Preview, or for same-tab Preview → Edit.
        let restoredDraft = false;
        if (parsedDraft && (restoreEditorDraft || (!this.editMode && this.previewMode))) {
          this.sceneData = parsedDraft;
          restoredDraft = true;
        }
        if (!restoredDraft) {
          this.sceneData = dbSceneData;
          if (this.editMode && getLocalData) {
            this.clearEditorPublishDraft();
          }
        }

        for (const scene of this.sceneData.scenes) {
          const rot = Number(scene.sceneRotationY);
          scene.sceneRotationY = Number.isFinite(rot) ? rot : 0;
        }

        this.scenes = getSceneDictionary(this.sceneData.scenes);
        this._sceneNorthById = this._sceneNorthById || {};
        this._sceneNorthOriginalById = this._sceneNorthOriginalById || {};
        this._sceneNorthCompassOverrideById = this._sceneNorthCompassOverrideById || {};
        for (const scene of this.sceneData.scenes) {
          const rot = Number(scene?.sceneRotationY);
          const val = Number.isFinite(rot) ? rot : 0;
          if (scene?.id) {
            if (!Object.prototype.hasOwnProperty.call(this._sceneNorthOriginalById, scene.id)) {
              this._sceneNorthOriginalById[scene.id] = val;
            }
            if (Number.isFinite(rot) && rot !== 0) {
              this._sceneNorthById[scene.id] = rot;
            }
          }
        }
        this.sceneHasLowResImage = {};
        Object.keys(this.scenes).forEach(key => {
          const scene = this.scenes[key];
          if (scene.publicName) {
            scene.name = scene.publicName;
          }
          const mediumPath = scene?.background?.mediumPath;
          if (!mediumPath) {
            this.sceneHasLowResImage[key] = false;
            return;
          }
          const lowResUrlImage = getLowResImageUrl(mediumPath);
          this.sceneHasLowResImage[key] = imageExists(lowResUrlImage);
        });


        this.currentScene = this.scenes[this.roomLocation];

        if (this.currentScene === undefined) {
          this.currentScene = this.sceneData.scenes[0]; // todo: home location will no longer be first scene in the array, it will be fetched based on it's id and the id will be set as a prop (home or entryPoint) inside worldData after ownerId
          this.roomLocation = this.currentScene.id;
          this.url.searchParams.set('loc', this.roomLocation);
        }

        this.scenesCanBeLocked = setScenesThatCanBeLocked(this.sceneData.scenes);
        this.userIsOwner = this.config ? (this.config.userId === responseData.creatorUserIdOfWorld) : null;
        if (this.editMode) {
          this.userIsContributor = Number(this.config.userData.id) !== Number(this.config.creator);
        } else {
          this.userIsContributor = this.config.userId !== responseData.creatorUserIdOfWorld
        }

        // Edit mode room data: BAGLESS ROOMS LIST & EVENTS
        this.worldsCanEnter = response.data.worldsCanEnter || worldsCanEnter;

        this.worldsCanEnter.forEach((item) => {
          const dropDownMenuItem = $(`<a class="dropdown-item bagless-room-option" data-id="${item.id}" data-name="${item.name}">${item.name} - Author</a>`);
          $("#bagless-room-dropdown-menu .dropdown-content").append(dropDownMenuItem);
        });

        let searchBaglessRoomDebounce;
        $("#search-bagless-room").on("keyup", (e) => {
          const val = $(e.currentTarget).val().toLowerCase();

          clearTimeout(searchBaglessRoomDebounce);

          searchBaglessRoomDebounce = setTimeout(() => {
            $("#bagless-room-dropdown-menu .dropdown-content").html("");

            if (val) {
              this.worldsCanEnter.forEach((item) => {
                if (item.name.toLowerCase().includes(val)) {
                  const dropDownMenuItem = $(`<a class="dropdown-item bagless-room-option" data-id="${item.id}" data-name="${item.name}">${item.name} - Author</a>`);
                  $("#bagless-room-dropdown-menu .dropdown-content").append(dropDownMenuItem);
                }
              });
            } else {
              this.worldsCanEnter.forEach((item) => {
                const dropDownMenuItem = $(`<a class="dropdown-item bagless-room-option" data-id="${item.id}" data-name="${item.name}">${item.name} - Author</a>`);
                $("#bagless-room-dropdown-menu .dropdown-content").append(dropDownMenuItem);
              });
            }
          }, 150);
        });

        $(".bagless-scene-dropdown").hide();

        $(document).on("click", ".bagless-room-option", (e) => {
          const name = $(e.currentTarget).data('name');
          const id = $(e.currentTarget).data('id');

          $("#bagless-room-dropdown-title").text(name);
          e.preventDefault();
          e.stopPropagation();
          $('#bagless_room_preview_image').addClass("check-aspect-ratio");
          $('#add_bagless_room_button').prop("disabled", true);
          $("#bagless-scene-dropdown-menu").removeClass("is-active");
          $("#bagless-room-dropdown-menu").removeClass("is-active");
          $("#bagless-scene-dropdown-menu .dropdown-content").empty();

          const successCallback = (response) => {
            this.newBagleesRoomObject.image = response.previewBackgroundImage;
            const oldImage = $('#bagless_room_preview_image');
            const image = thumbImageWithNormalCallback(response.previewBackgroundImage);
            image.attr("id", "bagless_room_preview_image")
            oldImage.replaceWith(image);
            $('#add_bagless_room_button').prop("disabled", false);
          };

          this.worldFetcher.getWorldDataFromId(Number(id), successCallback);
          this.newBagleesRoomObject = {};
          this.newBagleesRoomObject.id = id;
          this.newBagleesRoomObject.loc = 0;
        });

        ////

        this.global3DsceneObjects = [];
        this.sceneData.scenes.forEach(scene => {
          this.global3DsceneObjects = [...this.global3DsceneObjects, ...scene.objects]
        })

        const finishLoad = () => {
          this.dispatchEvent({ type: SCENE_EVENTS.SCENE_DATA_RECIEVED, data: this.sceneData });
          props.onOk && props.onOk(response.data);
        };

        if (this.worldID) {
          this.worldFetcher.listWorldEvents(this.worldID, (res) => {
            this.worldEvents = res?.events || [];
            this.worldActions = [];
            finishLoad();
          }, () => {
            this.worldEvents = [];
            this.worldActions = [];
            finishLoad();
          });
        } else {
          this.worldEvents = [];
          this.worldActions = [];
          finishLoad();
        }
      }
      const onErrorCallback = () => {
        this.sceneData = defaultWorld;
        this.dispatchEvent({ type: SCENE_EVENTS.SCENE_DATA_ERROR });
        props.onError && props.onError();
      }
      this.worldFetcher.getWorldData(url, onSuccesCallback, onErrorCallback);
    }

    this.getObjectDataByID = (sceneId, objId) => {
      const scenes = this.sceneData?.scenes;
      if (!Array.isArray(scenes)) {
        return undefined;
      }
      const searchScenes = sceneId ? scenes.filter((scene) => scene.id === sceneId) : scenes;
      for (const scene of searchScenes) {
        const objects = scene.objects || [];
        for (const obj of objects) {
          if (obj.id === objId) {
            return obj;
          }
        }
      }
      return undefined;
    }

    this.updateSpaceType = (props) => {
      const { url, data } = props;

      this.showLoading('updateSpaceType')

      this.dispatchEvent({ type: SCENE_EVENTS.SCENE_SAVED_STARTED });

      this.worldFetcher.updateSpaceType(url, data, (response) => {
        if (response.data?.success) {
          this.dispatchEvent({ type: SCENE_EVENTS.SPACE_TYPE_CHANGED, data: response });
        }
        this.hideLoading('updateSpaceType')
      }, (error) => {
        this.dispatchEvent({ type: SCENE_EVENTS.SCENE_SAVED_ERROR, data: error });

        this.hideLoading('updateSpaceType')
      });
    }

    this.saveSceneData = (props, initSave = false) => {
      const { url, data } = props;
      if (!initSave) {
        this.info('success', $trans('saving-changes'));
      }
      this.dispatchEvent({ type: SCENE_EVENTS.SCENE_SAVED_STARTED });

      this.worldFetcher.saveWorldData(url, data, initSave, (response) => {
        this.dispatchEvent({ type: SCENE_EVENTS.SCENE_SAVED_SUCCESS, data: response });
      }, (error) => {
        this.dispatchEvent({ type: SCENE_EVENTS.SCENE_SAVED_ERROR, data: error });
      })
    }
    this.uploadImage = (dom_element, clickable, temp_url, forceJpg, sliceImage, url, callbackFunction, crop = null, extraOptions = null) => {

      extraOptions = extraOptions || {};
      const methodController = {
        getBaseUrl: () => (''),
        getMaxFileUploadInMb: () => (3000),
        isEasyEditEnabled: () => (true)
      };

      const rest = new aptis.RestCommunicator();
      const fileDragDropUploadController = new aptis.wbt.easyEdit2.FileDragDropUploadController(methodController);
      const acceptedFiles = extraOptions.acceptedFiles || 'image/*';

      fileDragDropUploadController.initController(dom_element, clickable, acceptedFiles, temp_url,

        (fileNameOnServer, dropElement, originalFileName, file) => {
          const data = { fileNameOnServer, forceJpg, sliceImage };
          rest.postRequest(url, data, (error, result) => {
            if (error) {
              extraOptions.errorHandler?.(file || { name: originalFileName }, error);
              return;
            }
            callbackFunction(result.url, file);
          });
        },

        extraOptions.startHandler || null,
        extraOptions.errorHandler || null,
        crop,
        extraOptions
      );
      return fileDragDropUploadController;
    }

    window.generateThumbnail = (src) => {
      if (!this.URLS) return;

      if (src.includes("_thumb")) {
        const fileNameOnServer = src.replace('_thumb.', '.');

        if (imageExists(fileNameOnServer)) {

          $.post(this.URLS.addThumbnailUrl, { fileNameOnServer }, (data) => {
            let imageSrc = "./textures/empty.png";

            if (data.success) {
              imageSrc = data.url;
            }

            return imageSrc;

          }, "json");

        } else {
          return "./textures/empty.png";
        }
      } else {
        return "./textures/empty.png";
      }
    }

    this.uploadVideo = (dom_element, clickable, temp_url, forceJpg, sliceImage, url, callbackFunction) => {

      const methodController = {
        getBaseUrl: () => (''),
        getMaxFileUploadInMb: () => (3000),
        isEasyEditEnabled: () => (true)
      };

      const rest = new aptis.RestCommunicator();
      const fileDragDropUploadController = new aptis.wbt.easyEdit2.FileDragDropUploadController(methodController);
      fileDragDropUploadController.initController(dom_element, clickable, '.mp4,.mkv,.mov,.avi', temp_url,

        (fileNameOnServer, dropElement, originalFileName, file) => {
          // Extract metadata from original file before upload
          const metadata = {
            name: file.name,
            size: file.size,
            type: file.type,
            lastModified: file.lastModified
          };

          // Try to get video dimensions and thumbnail (optional, skip on error)
          const video = document.createElement('video');
          video.preload = 'metadata';

          video.onloadedmetadata = () => {
            metadata.width = video.videoWidth;
            metadata.height = video.videoHeight;
            metadata.duration = video.duration;

            // Try to generate thumbnail (optional)
            video.currentTime = 1;
          };

          video.onseeked = () => {
            try {
              const canvas = document.createElement('canvas');
              canvas.width = video.videoWidth;
              canvas.height = video.videoHeight;
              const ctx = canvas.getContext('2d');
              ctx.drawImage(video, 0, 0, canvas.width, canvas.height);
              metadata.thumbnail = canvas.toDataURL('image/jpeg', 0.8);
            } catch (e) {
              console.warn('Could not generate thumbnail:', e);
            }

            // Clean up
            URL.revokeObjectURL(video.src);
            video.remove();

            // Upload to server
            uploadToServer();
          };

          video.onerror = () => {
            console.warn('Could not load video metadata, continuing without it');
            // Clean up
            URL.revokeObjectURL(video.src);
            video.remove();

            // Upload to server anyway
            uploadToServer();
          };

          // Start loading video
          try {
            video.src = URL.createObjectURL(file);
          } catch (e) {
            console.warn('Could not create object URL:', e);
            uploadToServer();
          }

          function uploadToServer() {
            const data = { fileNameOnServer, forceJpg, sliceImage };
            rest.postRequest(url, data, (error, result) => {
              if (error) {
                console.log(error);
              } else {
                // Call callback with URL and metadata
                callbackFunction(result.url, metadata);
              }
            });
          }
        }
      );
    }

    this.saveProfile = (props, callback) => {
      const { url, data } = props;
      //url is rest endpoint save-profile -> actionSaveProfile
      this.worldFetcher.saveProfileData(url, data, (response) => {
        if (callback) {
          callback();
        }
        else {
          if (response.data === 1) {
            location.reload();
          }
        }
      }, (error) => {
        console.log('error', error);
      })
    }

    this.saveWorldTracking = (data) => {
      this.worldFetcher.saveWorldTrackingData(this.config.trackingUrl, data, (response) => {
      }, (error) => {
        console.log('error', error);
      })
    }

    /**
     * Persist space consent accept/decline (logged-in userId and/or guestId on server).
     * @returns {Promise|undefined}
     */
    this.saveSpaceConsentChoice = (payload) => {
      const url = this.config.spaceConsentSaveUrl;
      if (!url) {
        return Promise.resolve();
      }
      return this.worldFetcher.saveSpaceConsentData(
        url,
        payload,
        () => {},
        () => {}
      );
    }
    this.loadGlobalChatHistory = (worldId, callback) => {
      const onSuccess = (response) => {
        this.globalHistoryChat = response;
        this.dispatchEvent({ type: CHAT_EVENTS.GLOBAL_HISTORY_CHAT_LOADED });
        callback(response)
      }
      this.worldFetcher.getGlobalHistory(worldId, callback || onSuccess)
    }
    this.getGlobalHistoryChatMessages = (worldId, callback) => {
      if (this.globalHistoryChat) {
        this.dispatchEvent({ type: CHAT_EVENTS_OLD.GLOBAL_HISTORY_CHAT_LOADED });
        callback(this.globalHistoryChat)
      }
      else {
        this.loadGlobalChatHistory(worldId, callback);
      }
    }

    this.saveWorldCoordinates = (props) => {
      this.worldFetcher.saveWorldCoordinates(props, (response) => {
      }, (error) => {
        console.log('error', error);
      });
    }

    this.getRoomHistoryChatMessages = (sceneId, callback) => {
      const onSuccess = (response) => {
        this.dispatchEvent({ type: CHAT_EVENTS_OLD.LOCAL_ROOM_CHAT_HITORY_LOADED });
        callback(response.data)
      }
      const onError = (response) => {
        this.dispatchEvent({ type: CHAT_EVENTS_OLD.LOCAL_ROOM_CHAT_HITORY_LOADED_ERROR });
      }
      this.worldFetcher.getLocalRoomHistory(sceneId, callback || onSuccess, onError)
    }

    this.onSocketUserDataChangeRequested = (data) => {
      this.dispatchEvent({ type: SCENE_INTERACTION.SOCKET_USER_INFO_CHANGE_REQUESTED, data });
    }

    this.onSocketUserDataChanged = (data) => {
      this.dispatchEvent({ type: SCENE_INTERACTION.SOCKET_USER_INFO_CHANGED, data });
      //change my avatar on other chat
      let avatarClass = data.userId;
      if ($("#" + avatarClass) && $("#" + avatarClass).attr('src') !== undefined) {
        if ($("." + avatarClass).attr('src').includes(data.userAvatarUrl)) {
        } else {
          //new avatar
          let avatarUrl = data.userAvatarUrl;
          if (avatarUrl !== undefined) {
            const firstWord = avatarUrl.split('/')[0]
            if (firstWord === 'virtualRealityFiles') {
              let avatar = this.config.baseWebUrl + data.userAvatarUrl;
              $("." + avatarClass).attr('src', avatar);
            } else {
            }
          }
        }
      }
      if (data.guide) {
        this.guideUserId = data.userId;
      }
    }

    this.socketUserDisconnected = (userData) => {
      this.dispatchEvent({ type: SCENE_EVENTS.SOMEONE_LEAVED_ROOM, data: userData });
      if ((this.guideUserId === userData.userId) && this.tourMode) {
        this.onTourEnded();
      }
      this.removeUserFromInvitationTourList(userData.userId);
    };

    this.removeUserFromInvitationTourList = (userId) => {
      if (this.listInvitationTour.has(userId)) {
        this.listInvitationTour.delete(userId);
      }
    }

    this.onUserSceneChange = (newSceneId, dbConfig) => {
      this.currentScene = this.scenes[newSceneId] ? this.scenes[newSceneId] : this.currentScene;
      this.socket.getUserData().sceneName = this.getCurrentSceneName();
      this.socket.getUserData().currentSceneId = newSceneId;
      this.worldFetcher.sendTrack({ event: TRACK_EVENTS.USER_CHANGING_SCENE, data: { user: this.socket.getUserData(), from: this.currentScene.id, to: newSceneId } })
      this.dispatchEvent({ type: SCENE_INTERACTION.USER_SCENE_CHANGED, data: { sceneID: newSceneId, dbConfig } })
    }
    this.changeMood = (mood) => {
      this.dispatchEvent({ type: SCENE_INTERACTION.USER_MOOD_CHANGED, data: { mood } })
    }
    this.onUserClosedInitDeviceCheckModal = (mood) => {
      this.dispatchEvent({ type: SCENE_EVENTS.USER_INIT_MODAL_CLOSE, data: { mood } })
    }
    this.onTakeSeat = (dbConig) => {
      this.worldFetcher.sendTrack({ event: TRACK_EVENTS.TAKE_SEAT, user: this.socket.getUserData(), seat: dbConig })
      this.dispatchEvent({ type: SCENE_INTERACTION.USER_TAKES_SEAT, data: dbConig });
    }
    this.onTakeSeatEmpty = (dbConig) => {
      this.dispatchEvent({ type: SCENE_INTERACTION.USER_TAKES_SEAT_EMPTY, data: dbConig })
    }
    this.tourOnTakeScreenShareSeat = (data) => {
      this.dispatchEvent({ type: SCENE_INTERACTION.TOUR_MODE_USER_TAKES_SCREEN_SHARE_SEAT, data })
    }

    this.onTakeScreenShareSeat = (dbConig) => {
      this.dispatchEvent({ type: SCENE_INTERACTION.USER_TAKES_SCREEN_SHARE_SEAT, data: dbConig })
    }
    this.tourOnScreenShareSeatStandUp = (data) => {
      this.dispatchEvent({ type: SCENE_INTERACTION.TOUR_MODE_USER_SCREEN_SHARE_SEAT_STAND_UP })
    }
    this.onStandUp = (dbConig) => {
      this.dispatchEvent({ type: SCENE_INTERACTION.USER_LEAVES_SEAT, data: dbConig })
    }
    this.onStandUpFromScreenShare = (dbConig) => {
      this.dispatchEvent({ type: SCENE_INTERACTION.USER_LEAVES_SCREEN_SHARE, data: dbConig })
    }
    this.onOpenMediaSettings = () => {
      this.dispatchEvent({ type: SCENE_EVENTS.OPEN_SETTING_MENU })
    }
    this.setOccupiedSeat = (payload, currentUsers) => {
      this.occupiedSeats = payload;
      this.dispatchEvent({ type: SCENE_INTERACTION.SET_OCCUPIED_SEATS, data: { payload, currentUsers } })
    }
    this.setOccupiedScreenShareSeat = (payload, currentUsers) => {
      this.screenShareOccupiedSeats = payload;
      this.dispatchEvent({ type: SCENE_INTERACTION.SET_OCCUPIED_SCREEN_SHARE_SEATS, data: { payload, currentUsers } })
    }
    this.tour_setOccupiedScreenShareSeat = (payload) => {
      this.tour_screenShareOccupiedSeats = payload;
      this.dispatchEvent({ type: SCENE_INTERACTION.TOUR_SET_OCCUPIED_SCREEN_SHARE_SEATS })
    }
    this.isThisOccupiedScreen = (objId) => {
      return this.socket.isScreenObjIdOccupied(objId);
    }
    this.setOccupiedScreen = (payload, currentUsers) => {
      this.occupiedScreens = payload;
      this.dispatchEvent({ type: SCENE_INTERACTION.SET_OCCUPIED_SCREENS, data: { payload, currentUsers } })
    }
    this.onTakeScreen = (dbConig) => {
      this.dispatchEvent({ type: SCENE_INTERACTION.USER_TAKES_SCREEN, data: dbConig })
    }
    this.onStopScreen = (dbConig, userId) => { //TODO  typo dbConig
      this.dispatchEvent({ type: SCENE_INTERACTION.USER_STOP_SCREEN, data: { dbConig, userId } })
    }
    this.setLockedRooms = (payload, currentUsers) => {
      this.lockedRooms = payload.lockedRooms;
      this.dispatchEvent({
        type: SCENE_INTERACTION.SET_LOCKED_ROOMS, data: { payload, currentUsers }
      })
    }
    this.onSceneInitialised = (payload, currentUsers) => {
      this.dispatchEvent({ type: SCENE_INTERACTION.SCENE_INITIALISED, data: { payload, currentUsers } })
    }
    this.onNewSceneInitialised = () => {
      this.dispatchEvent({ type: SCENE_INTERACTION.NEW_SCENE_INITIALISED })
    }
    this.onNewGuestJoinedPublicStage = () => {
      this.dispatchEvent({ type: SCENE_INTERACTION.NEW_GUEST_ON_PUBLIC_STAGE })
    }
    this.onUserLeftPublicStage = (userId) => {
      this.dispatchEvent({ type: WEBRTC_EVENTS.LEFT_PUBLIC_STAGE, data: userId });
    }
    this.onNewUserJoinedPublicStage = () => {
      this.dispatchEvent({ type: SCENE_INTERACTION.NEW_USER_ON_PUBLIC_STAGE })
    }
    this.onNewStreamOnPublicStage = (obj3Did, userdata) => {
      this.dispatchEvent({ type: WEBRTC_EVENTS.NEW_STREAM_ON_PUBLIC_STAGE, data: { obj3Did, userdata } })
    }
    this.onAnimationStart = () => {
      this.isAnimating = true;
      this.dispatchEvent({ type: SCENE_INTERACTION.START_ANIMATION })
    }
    this.onAnimationStop = () => {
      this.isAnimating = false;
      this.dispatchEvent({ type: SCENE_INTERACTION.STOP_ANIMATION })
    }
    this.customSceneChange = (data) => {
      this.dispatchEvent({ type: SCENE_INTERACTION.CUSTOM_CHANGE_SCENE, data })
    }
    this.lockScene = (data) => {
      this.dispatchEvent({ type: SCENE_INTERACTION.LOCK_SCENE })
    }
    this.unlockScene = (data) => {
      this.dispatchEvent({ type: SCENE_INTERACTION.UNLOCK_SCENE })
    }
    this.playSound = (url) => {
      this.dispatchEvent({ type: SCENE_INTERACTION.PLAY_SOUND, url })
    }
    this.hideSceneElements = () => {
      this.dispatchEvent({ type: SCENE_INTERACTION.HIDE_ELEMENTS })
    }
    this.showSceneElements = () => {
      this.dispatchEvent({ type: SCENE_INTERACTION.SHOW_ELEMENTS })
    }
    this.showSelfCheckModal = () => {
      this.dispatchEvent({ type: SHOW_MODAL.SELF_CHECK });
    }
    let loadingActions = new Set();
    this.showLoading = (action) => {
      loadingActions.add(action);
      $(".loading-spinner").addClass('visible');
      $('.loader-wrapper-cross').addClass('is-active');
      $('.spinner-background-wrapper').addClass('is-active');
      $('.wrapper-loading-image').show();
    }
    this.hideLoading = (action) => {
      loadingActions.delete(action);
      if (loadingActions.size === 0) {
        $(".loading-spinner").removeClass('visible');
        $('.loader-wrapper-cross').removeClass('is-active');
        $('.spinner-background-wrapper').removeClass('is-active');
        $('.wrapper-loading-image').hide();
      }
    }
    ////TOUR ' GUIDE
    this.onTourStarted = (tourId) => {
      this.tourMode = true;
      document.querySelectorAll('.close-modal').forEach(element => {
        element.classList.add('disabled');
      });
      document.querySelectorAll('.modal-content .close-modal').forEach(element => {
        $(element).trigger("click")
      });
      document.querySelectorAll('.image-gallery').forEach(element => {
        const left = $(element).find("#left");
        const right = $(element).find("#right");
        left && left.addClass("disabled")
        right && right.addClass("disabled")
      });
      this.socket.socketTour.onStartTourInterval();
      this.dispatchEvent({ type: SCENE_EVENTS.TOUR_MODE_STARTED, data: tourId });
      this.dispatchEvent({ type: SCENE_EVENTS.GRID_MODE, data: { showGrid: false } });
    }
    this.onInviteToChair = (data) => {
      this.socket.sendChairInvite(data);
    }
    this.onSendChairInvite = (payload) => {
      const { receiverId, obj_id } = payload;
      if (receiverId === this.config.userId) {
        this.dispatchEvent({ type: SCENE_EVENTS.CUSTOM_TAKE_SEAT, payload })
      }
    }
    this.onTourStartedWithoutCamera = () => {
      this.tourMode = true;
      this.dispatchEvent({ type: SCENE_EVENTS.TOUR_MODE_STARTED })
    }
    this.onTourEnded = () => {
      if (this._tourEndInProgress) {
        return;
      }
      this._tourEndInProgress = true;
      document.querySelectorAll('.modal-content .close-modal').forEach(element => {
        $(element).trigger("click")
      });
      document.querySelectorAll('.image-gallery').forEach(element => {
        const left = $(element).find("#left");
        const right = $(element).find("#right");
        left && left.removeClass("disabled")
        right && right.removeClass("disabled")
      });
      document.querySelectorAll('.close-modal').forEach(element => {
        element.classList.remove('disabled');
      });
      document.querySelectorAll('.close-modal').forEach(element => {
        element.classList.remove('disabled');
      });
      this.tourMode = false;
      this.outgoingPodiumInvites?.clear();
      this.podiumInviteState?.clear();
      this.guide = null;
      this.clearOneToOneTour();
      this.tourContributore = null;
      this.isTourGuest = false
      this.socket.disableGuidedCamera();
      this.socket.socketTour.exitTour();
      this.dispatchEvent({ type: SCENE_EVENTS.TOUR_MODE_ENDED })
      this.dispatchEvent({ type: NOTIFICATION_EVENTS.CLOSE })
      this.socket.socketTour.onStopTourInterval();
      this.socket.onStopGuideMode();
      this._tourEndInProgress = false;
    }
    this.onTourInvitation = (payload, showInvitation = false) => {
      this.dispatchEvent({ type: SCENE_EVENTS.ON_TOUR_INVITATION })
    }
    this.onToggleGuideMode = () => {
      if (this.isTalkingWithAgent()) {
        this.showTalkingWithAgentError();
        return;
      }
      this.guidedMode = !this.guidedMode;
      if (!this.tourStartForm) {
        this.tourStartForm = new TourStartForm({
          model: this,
          socket: this.socket,
          onConfirm: (values) => {
            this.guide = true;
            const data = {
              inputValue: values.name,
              componentValue: values.invitations,
              visibility: values.visibility,
              id: this.config.userId,
            }
            this.dispatchEvent({ type: SCENE_EVENTS.GUIDED_MODE_START, data });
            this.dispatchEvent({ type: NOTIFICATION_EVENTS.CLOSE });
            this.tourStartForm.reset()
          }
        });
      }

      if (this.guidedMode) {
        this.tourStartForm.reset()
        this.confirm(
          this.tourStartForm.template,
          (values) => {
          },
          {
            modalTheme: CONFIRM_NOTIFICATION_THEME.DARK,
            modalSize: CONFIRM_NOTIFICATION_SIZE.SM,
            header: true,
            title: $trans('start-tour-title'),
            confirmBtnTxt: $trans('start-tour-btn'),
            xBtn: true,
            successBtn: false,
            cancelBtn: false,
            logo: false,
          },
          () => {
            this.guidedMode = false;
          },
        )
        this.dispatchEvent({ type: SCENE_EVENTS.GRID_MODE, data: { showGrid: false } });
      } else {
        this.guide = false;
        this.clearOneToOneTour();
        this.dispatchEvent({ type: SCENE_EVENTS.GUIDED_MODE_STOP })
        this.socket.onStopGuideMode();
      }
    }
    this.startTourFromMenu = (visibility) => {
      this.pendingPodiumGuest = null;
      if (this.isTalkingWithAgent()) {
        this.showTalkingWithAgentError();
        return;
      }
      const userName = this.socket.getUserData().userName;
      this.clearOneToOneTour();
      this.pendingOneToOne = visibility === 'oneToOne';
      this.hostingOneToOne = visibility === 'oneToOne';
      this.guide = true;
      this.guidedMode = true;
      this.dispatchEvent({
        type: SCENE_EVENTS.GUIDED_MODE_START,
        data: {
          inputValue: $trans('start-tour-default-name', { userName }),
          componentValue: [],
          visibility,
          id: this.config.userId,
        },
      });
      this.dispatchEvent({ type: NOTIFICATION_EVENTS.CLOSE });
      this.dispatchEvent({ type: SCENE_EVENTS.GRID_MODE, data: { showGrid: false } });
    }
    this.startOneOnOneTourWith = (socketUser) => {
      if (this.isTalkingWithAgent()) {
        this.showTalkingWithAgentError();
        return;
      }
      if (!socketUser?.userId || !socketUser?.socketId) {
        this.info('info', $trans('start-one-on-one-user-offline'));
        return;
      }
      if (String(socketUser.userId) === String(this.config.userId)) {
        return;
      }
      if (!this.canRunTour()) {
        this.alert('error', $trans('start-one-on-one-unavailable'));
        return;
      }
      if (this.iAmGuide()) {
        this.inviteUserToPodium(socketUser);
        return;
      }
      this.startTourFromMenu('oneToOne');
      if (this.guidedMode && this.hostingOneToOne) {
        this.pendingPodiumGuest = socketUser;
      }
    }
    this.onToggleQuickInviteToTour = () => {
      this.promptWithConfirm(`Invite People to tour`, null, (values) => {
        const { inputValue, componentValue } = values;
      }, {
        header: true, title: 'Start Guided Tour', placeholder: "Tour name", confirmBtnTxt: "Start tour", xBtn: true, customComponent: new UserSelectorWithButton({ model: this, socket, container: $(".confirm-custom-component") })
      });
    }
    this.onTourSettings = () => {
      if (!this.tourData[tourID]) {
        return;
      }
      if (this.guidedMode) {
        this.promptWithConfirm(`Tour Settings`, null, (values) => {
          const { inputValue, componentValue } = values;
          this.socket.socketTour.onEditTourData({ name: values })
        }, {
          header: false, title: 'Tour Settings', placeholder: "Tour name", confirmBtnTxt: "Update", xBtn: true,
        });

      } else {
        this.dispatchEvent({ type: SCENE_EVENTS.GUIDED_MODE_STOP })
        this.socket.onStopGuideMode();
      }
    }
    this.tourContributeAdded = () => {
      this.dispatchEvent({ type: SCENE_EVENTS.TOUR_CONTRIBUTE_ADDED })
    }
    this.tourContributorRemoved = () => {
      this.dispatchEvent({ type: SCENE_EVENTS.TOUR_CONTRIBUTE_REMOVED })
    }
    this.tourNewUser = () => {
      this.dispatchEvent({ type: SCENE_EVENTS.TOUR_NEW_USER })
    }
    this.tourContributeInvite = (payload) => {
      this.confirm(`Owner is inviting you as tour guide`, () => {
        this.onTourStarted(name);
        this.tourContributore = true;
        this.socket.disableGuidedCamera();
        this.dispatchEvent({ type: SCENE_EVENTS.ON_TOUR_CONTRIBUTORE_ACCEPTED })
      }, { header: true, title: 'Guided tour invitation' });
      this.dispatchEvent({ type: SCENE_EVENTS.ON_TOUR_INVITATION })
    }
    this.tourPodiumInvite = (payload) => {
      const guide = this.socket._currentUserData[payload.senderId];
      const guideName = guide?.userName || '';
      const tourName = payload.tour?.name || '';
      const tourId = payload.tourId || payload.tour?.id;
      this.confirm($trans('is-inviting-you-to-podium', { user: guideName, name: tourName }), async () => {
        if (!(await requestMediaPermissions('all', this))) {
          tourId && this.socket.socketTour.podiumRefuseInvitation(this.config.userId, payload.senderId, tourId);
          return;
        }
        if (payload.tour && tourId && !this.tourData[tourId]) {
          this.tourData[tourId] = payload.tour;
        }
        if (this.tourModeController) {
          this.tourModeController.pendingPodiumPublish = true;
        }
        this.joiningOneToOnePodium = true;
        try {
          let tourStarted = this.iAmInTour();
          if (!tourStarted && tourId) {
            const tour = this.tourData[tourId] || payload.tour;
            if (tour) {
              this.onTourStarted(tourId);
              this.socket.acceptGuideMode(tour);
              tourStarted = tour;
            }
          }
          const acceptTourId = tourStarted?.id || tourId;
          acceptTourId && this.socket.socketTour.acceptPodium(acceptTourId);
        } finally {
          this.joiningOneToOnePodium = false;
        }
        this.isTourGuest = true;
        this.dispatchEvent({ type: SCENE_EVENTS.ON_TOUR_GUEST_ACCEPTED });
      }, {
        header: true,
        title: $trans('invite-to-podium-menu-text'),
        logo: false,
        modalTheme: CONFIRM_NOTIFICATION_THEME.DARK,
        modalType: CONFIRM_NOTIFICATION_TYPE.DEFAULT,
        modalSize: CONFIRM_NOTIFICATION_SIZE.SM,
      }, () => {
        tourId && this.socket.socketTour.podiumRefuseInvitation(this.config.userId, payload.senderId, tourId);
      });
      this.dispatchEvent({ type: SCENE_EVENTS.ON_TOUR_GUEST_INVITATION });
    }
    this.exitTour = () => {
      this.onTourEnded();
    }
    ////TOUR ' GUIDE

    this.onNavbarOpen = () => {
      ///closes UI stuff
      this.navbarItemClicked();
    }
    this.onUserTogglesCameraOnCta = () => {
      this.dispatchEvent({ type: SCENE_INTERACTION.USER_TOGGLE_CAMERA_ON_CTA_MENU })
      this.socket.userToggleCamera();
    }
    this.onUserTogglesMicrophoneOnCta = () => {
      this.socket.userToggleMicrophone();
    }
    this.isSocketUserMicMuted = (user) => {
      if (!user) return true;
      return !!(user.userAudioMuted || user.userMicOn === false || user.userWantsAudio === false);
    }
    this.requestToggleOtherUserMic = (user, muted = null) => {
      if (!user?.userId) return;
      if (String(user.userId) === String(this.config.userId)) return;
      const liveUser = this.socket.getUsersObject()?.[user.userId] || user;
      const nextMuted = muted === null ? !this.isSocketUserMicMuted(liveUser) : !!muted;
      this.socket.requestUpdateUserData(liveUser.userId, { userAudioMuted: nextMuted });
    }
    this.inviteUserToRoom = (socketUser) => {
      const { userId } = socketUser;
      const currentSceneId = this.currentScene.id;
      this.socket._inviteUserToRoom(userId, currentSceneId)
    }
    this.inviteUserToTour = (socketUser) => {
      const { userId, socketId } = socketUser;
      const tourStarted = this.iAmInTour();
      if (!tourStarted) {
        this.alert("error", "No tour found");
        return;
      }
      if (this.isOneToOneTour(tourStarted)) {
        this.info('info', $trans('one-to-one-tour-closed'));
        return;
      }
      if (this.pendingTourInvitations.has(String(userId))) {
        return;
      }
      this.rememberTourInvitation(tourStarted, socketId, { podium: false });
      this.socket.inviteAsTourGuest(userId, socketId, tourStarted);
      const alreadyInTour = Array.isArray(tourStarted.users) && tourStarted.users.includes(socketId);
      if (!alreadyInTour) {
        this.pendingTourInvitations.set(String(userId), "guests");
      }
      this.info('info', $trans('tour-invitation-sent-text'));
      this.listInvitationTour.set(userId, socketUser);
      this.dispatchEvent({ type: SCENE_EVENTS.UPDATE_TOUR_UI_ON_SOCKET_DATA });
    }
    this.inviteUserToPodium = (socketUser) => {
      const { userId, socketId } = socketUser;
      const tourStarted = this.iAmInTour();
      if (!tourStarted) {
        this.alert("error", "No tour found");
        return;
      }
      if (this.isOneToOneTour(tourStarted) && !this.oneToOneSeatOpen(tourStarted)) {
        this.info('info', $trans('one-to-one-tour-seat-taken'));
        return;
      }
      if (this.pendingTourInvitations.has(String(userId))) {
        return;
      }
      this.rememberTourInvitation(tourStarted, socketId, { podium: true });
      this.socket.inviteToPodium(userId, socketId, tourStarted);
      const alreadyOnPodium = Array.isArray(tourStarted.podiumUsers) && tourStarted.podiumUsers.includes(socketId);
      if (!alreadyOnPodium) {
        this.pendingTourInvitations.set(String(userId), "podium");
        this.outgoingPodiumInvites.set(String(userId), socketUser);
        this.podiumInviteState.set(String(userId), 'pending');
      }
      this.info('info', $trans('podium-invitation-sent-text'));
      this.dispatchEvent({ type: SCENE_EVENTS.UPDATE_TOUR_UI_ON_SOCKET_DATA });
    }
    this.markPodiumInviteAccepted = (userId) => {
      const key = String(userId);
      if (!this.outgoingPodiumInvites.has(key) || this.podiumInviteState.get(key) === 'declined') {
        return;
      }
      this.podiumInviteState.set(key, 'accepted');
    }
    this.markPodiumInviteDeclined = (userId) => {
      const key = String(userId);
      if (!this.outgoingPodiumInvites.has(key) || this.podiumInviteState.get(key) === 'accepted') {
        return;
      }
      this.podiumInviteState.set(key, 'declined');
    }
    this.clearPendingTourInvitation = (userId, kind, { notify = true } = {}) => {
      if (userId == null) {
        return;
      }
      const key = String(userId);
      const current = this.pendingTourInvitations.get(key);
      if (!current || (kind && current !== kind)) {
        return;
      }
      this.pendingTourInvitations.delete(key);
      const tour = this.iAmInTour();
      const user = this.socket.getUsersObject()?.[userId] || this.socket.getUsersObject()?.[key];
      const socketId = user?.socketId;
      if (tour && socketId) {
        if (Array.isArray(tour.invitedToPodium)) {
          tour.invitedToPodium = tour.invitedToPodium.filter((id) => id !== socketId);
        }
        if (Array.isArray(tour.invitedUsers)) {
          tour.invitedUsers = tour.invitedUsers.filter((id) => id !== socketId);
        }
      }
      if (notify) {
        this.dispatchEvent({ type: SCENE_EVENTS.UPDATE_TOUR_UI_ON_SOCKET_DATA });
      }
    }
    this.removeUserFromPodium = (socketUser) => {
      const tourStarted = this.iAmInTour();
      if (!tourStarted || !this.iAmGuide() || !socketUser) {
        return;
      }
      this.socket.removeUserFromPodium(socketUser, tourStarted);
    }
    this.removeUserFromTour = (socketUser) => {
      const tourStarted = this.iAmInTour();
      if (!tourStarted || !this.iAmGuide() || !socketUser) {
        return;
      }
      this.socket.removeUserFromTour(socketUser, tourStarted);
    }
    this.onRemovedFromPodium = () => {
      this.isTourGuest = false;
      const tour = this.iAmInTour();
      const socketId = this.socket.getUserData().socketId;
      if (tour && socketId) {
        if (Array.isArray(tour.podiumUsers)) {
          tour.podiumUsers = tour.podiumUsers.filter((id) => id !== socketId);
        }
        if (Array.isArray(tour.guests)) {
          tour.guests = tour.guests.filter((id) => id !== socketId);
        }
        if (tour.streams && tour.streams[socketId]) {
          delete tour.streams[socketId];
        }
      }
      this.dispatchEvent({ type: SCENE_INTERACTION.KILL_GUEST_MODE_SOCKET_REQUEST });
      this.dispatchEvent({ type: SCENE_EVENTS.UPDATE_TOUR_UI_ON_SOCKET_DATA });
    }
    this.onRemovedFromTour = () => {
      if (!this.tourMode) {
        return;
      }
      this.onTourEnded();
    }
    this.rememberTourInvitation = (tour, socketId, { podium = false } = {}) => {
      if (!tour || !socketId) {
        return;
      }
      const oneToOne = this.isOneToOneTour(tour);
      const alreadyInTour = Array.isArray(tour.users) && tour.users.includes(socketId);
      if (!oneToOne && !alreadyInTour) {
        if (!Array.isArray(tour.invitedUsers)) {
          tour.invitedUsers = [];
        }
        if (!tour.invitedUsers.includes(socketId)) {
          tour.invitedUsers.push(socketId);
        }
      }
      if (podium) {
        if (!Array.isArray(tour.invitedToPodium)) {
          tour.invitedToPodium = [];
        }
        if (!tour.invitedToPodium.includes(socketId)) {
          tour.invitedToPodium.push(socketId);
        }
      }
    }
    this.onChessInvitation = (payload) => {
      const inviter = this.socket.getUsersObject()[payload.senderId];
      const inviterName = inviter?.userName || $trans('someone-text');
      const message = `${inviterName} ${$trans('is-inviting-you-to-join-chess')}`;
      const joinChess = () => {
        const gameId = payload.gameId;
        if (payload.sceneId !== this.socket.getUsersObject()[this.config.userId].currentSceneId) {
          this.dispatchEvent({
            type: SCENE_INTERACTION.JUMP_TO_SCENE, data: {
              sceneId: payload.sceneId,
              onComplete: () => {
                this.openChessModal({ gameId: gameId }, this.config.userId);
              }
            }
          });
        } else {
          this.openChessModal({ gameId: gameId }, this.config.userId);
        }
      };
      this.confirm(message, joinChess, { header: false, confirmBtnTxt: $trans('join-scene-text'), cancelBtnTxt: $trans('cancel-text') });
    }
    this.inviteUserToRoomGlobal = (socketUser) => {
      const { userId } = socketUser;
      const currentSceneId = this.currentScene.id;
      this.socket.inviteGlobalTour(userId, currentSceneId, this.tourData)
    }
    this.onSendUserJoinRoomInvitation = (payload) => {
      const user = this.socket.getUsersObject()[payload.senderId];
      const message = `${user.userName} ${$trans('is-inviting-you-to-join-room')}`;
      const { wantedSceneId } = payload;
      this.confirm(message, () => {
        this.dispatchEvent({
          type: SCENE_INTERACTION.JUMP_TO_SCENE, data: {
            sceneId: wantedSceneId
          }
        });
      }, { header: false, confirmBtnTxt: $trans('join-scene-text'), cancelBtnTxt: $trans('cancel-text') });
    }
    this.onUserInvertsCamera = () => {
      this.dispatchEvent({ type: SCENE_EVENTS.USER_INVERTS_CAMERA })
    }

    this.askForLockedRoomEnter = (sceneId) => {
      this.iWantToScene = sceneId;
      this.onSendPrivateRequest(
        {
          message: "request",
          userName: this.config.userName,
          userId: this.config.userId,
          wantedSceneId: sceneId
        }
      );
    }
    this.approveEnterRoomrequest = (approve, msg) => {
      if (!this.lockRequestUser) { return }
      const { userId, userName, senderId } = this.lockRequestUser;
      this.onAcceptPrivateRequest(
        {
          message: msg,
          userName: userName,
          userId: senderId,
          approve,
        },
      );
    }
    this.clearLockRequestData = () => {
      this.sendRequestToUser = null;
      this.lockRequestUser = null;
      this.iWantToScene = null;
    }
    this.attachSinkId = async (element, sinkId) => {
      return;
    }

    this.addEventListener(CHAT_EVENTS.EXPAND, () => {
      this.chatState.expanded = true;
    });
    this.addEventListener(CHAT_EVENTS.SHRINK, () => {
      this.chatState.expanded = false;
    });

    this.addEventListener(SOCKET_EVENTS.FREEZE_SESSION, () => {
      this.isFrozenSession = true;
    })

    this.addEventListener(SOCKET_EVENTS.RESUME_SESSION, () => {
      this.isFrozenSession = false;
    })
  }

  /**
   * GET MEDIA DEVICES AND PLACE THEM INSIDE SELECT
   */
  getMediaDevices = () => {
    //TODO bug taking my exteral USB camera that is not plugged in any more
    const audioInputSelect = document.querySelectorAll('select.microphoneSelect');
    const videoSelect = document.querySelectorAll('select.cameraSelect');
    const audioOutputSelect = document.querySelectorAll('select.speakerSelect');
    const selectorsNode = [audioInputSelect, videoSelect, audioOutputSelect];

    audioOutputSelect.forEach(select => {
      if (!('sinkId' in HTMLMediaElement.prototype)) {
        this.hideMediaDevices = true;
        select.disabled = true;
        $(".sound-section").hide();
      }
    });

    function createOption(value, text, storedDevice) {
      const option = document.createElement('option');
      if (storedDevice && storedDevice == value) {
        option.selected = true;
      }
      option.value = value;
      option.text = text;
      return option;
    }

    const gotDevices = (deviceInfos) => {
      selectorsNode.forEach(selectNode => {
        selectNode.forEach(select => {
          while (select.firstChild) {
            select.removeChild(select.firstChild);
          }
        });
      });


      for (let i = 0; i !== deviceInfos.length; ++i) {
        const deviceInfo = deviceInfos[i];
        const deviceId = deviceInfo.deviceId;
        if (!this.deviceInfos) {
          this.deviceInfos = {};
        }
        this.deviceInfos[i] = deviceInfo;

        if (deviceInfo.label) {
          this.hideMediaDevices = false;
        }
        localStorage.removeItem('audiooutput')
        if (!deviceId) {
          this.hideMediaDevices = true;
        }

        if (deviceInfo.kind === 'audioinput') {
          let storedDevice = null;
          if (localStorage.hasOwnProperty('microphoneDevice')) {
            storedDevice = localStorage.getItem('microphoneDevice');
            if (deviceId == storedDevice) {
              // console.log('select this microphoneDevice: ', storedDevice);
            }
          }
          const text = deviceInfo.label || `Microphone ${audioInputSelect[0].length + 1}`;
          deviceId && audioInputSelect.forEach(select => select.appendChild(createOption(deviceId, text, storedDevice)));
        } else if (deviceInfo.kind === 'audiooutput') { //firefox bug - always using OS default
          const text = deviceInfo.label || `Speaker ${audioOutputSelect[0].length + 1}`;
          let storedDevice = null;
          if (localStorage.hasOwnProperty('soundDevice')) {
            storedDevice = localStorage.getItem('soundDevice');
            if (deviceId == storedDevice) {
            }
          }
          deviceId && audioOutputSelect.forEach(select => select.appendChild(createOption(deviceId, text, storedDevice)));
        } else if (deviceInfo.kind === 'videoinput') {
          const text = deviceInfo.label || `Camera ${videoSelect[0].length + 1}`;
          let storedDevice = null;
          if (localStorage.hasOwnProperty('cameraDevice')) {
            storedDevice = localStorage.getItem('cameraDevice');
            if (deviceId == storedDevice) {
            }
          }
          deviceId && videoSelect.forEach(select => {
            select.appendChild(createOption(deviceId, text, storedDevice))
          });
        } else {

        }
      }

      // this.hideMediaDevices ? $(".source-device").hide() : $(".source-device").show();
      this.customSelect.refresh();
    }

    function handleError(error) {
      console.log('navigator.MediaDevices.getUserMedia error: ', error.message, error.name);
    }

    navigator.mediaDevices.enumerateDevices().then(gotDevices).catch(handleError);
  }

  testifStoredDevices = () => {
    if (localStorage.hasOwnProperty('microphoneDevice')) {
      console.log('mic stored:     ', localStorage.getItem('microphoneDevice'));
      console.log('mic selected:   ', $(".microphoneSelect").val());
    }
    if (localStorage.hasOwnProperty('cameraDevice')) {
      let stored = localStorage.getItem('cameraDevice');
      let selected = $(".cameraSelect").val();
      console.log('cam stored:     ', stored);
      console.log('cam selected:   ', selected);
    }

    if (localStorage.hasOwnProperty('soundDevice')) {
      console.log('sound stored:    ', localStorage.getItem('soundDevice'));
      console.log('sound selected:  ', $(".speakerSelect").val());
    }
  }

  resetChatState() {
    Object.keys(this.chatState).forEach((key) => {
      this.chatState[key] = false
    })
  }

  /**
   * TEST INDICATORS FOR STREAM CONFIG
   */
  testStream = async (isScreenShare) => {
    const _data = getUsersPreferedSettings();
    const { audio, video } = _data
    this.userChangesCameraFromScreenShareWodal = isScreenShare;
    this.testifStoredDevices();
    // let audio = $(".microphoneSelect").val();
    // let video = $(".cameraSelect").val();
    let soundDevice = $(".speakerSelect").val();
    this.showLoading()
    $("#submit_take_seat").addClass('disabled');

    this.endTestStream();

    // this.selectedVideoFromDropDown = video;
    // this.selectedAudioFromDropDown = audio;
    // webrtc.switchVideo(video);
    // webrtc.switchAudio(audio);
    let data = {
      audio: { ...audio },
      video: { ...video }
    }

    navigator.mediaDevices.getUserMedia(data)
      .then(stream => {
        this._localStream?.getTracks().forEach(track => track.stop());

        this._localStream = stream

        //new webrtc myVideo player holder
        this.hideMediaDevices && this.getMediaDevices();
        // if (this.cameraStream) {
        //   this.killStream(this.cameraStream);
        // }
        // this.getCameraHTMLObject().srcObject = stream;

        //inform socket users about resolution from users camera
        const settings = stream.getVideoTracks()[0].getSettings();
        if (settings) {
          const { width, height, deviceId } = settings;
          const videosInfo = { camera: { width, height } };
          this.videosInfo = videosInfo;
          this.socket.userStartedWebRTCStream(videosInfo);
          this.setOldDeviceSettingsCameraValue(deviceId);
        }

        this.hideLoading();
        this.hideLoading();

        if (!this.activePreviewVideoModal) {
          this.endTestStream();
          return;
        }
        // if (!this.userChangesCameraFromScreenShareWodal) {
        //   this.getCameraHTMLObject().srcObject = stream;
        // }
        // $('.video-indicator').each(function (index, el) {
        //   el.srcObject = stream; //TODO listen when loaded
        // });
        //
        // if (this.tourIsRunning()) {
        //   $('#myTourVideo').each(function (index, el) {
        //     el.srcObject = stream; //TODO listen when loaded
        //   });
        // }
        if (this.tourModeController && this.tourModeController.publishStreamId) {
          let video = this.view.deviceSettingsMenu.selected.camera.value;
          let audio = this.view.deviceSettingsMenu.selected.microphone.value;
          video & this.tourModeController.switchVideo(video);
          audio && this.tourModeController.switchAudio(audio);
        }
        const audioContext = new AudioContext();
        const audioSource = audioContext.createMediaStreamSource(stream);
        const analyser = audioContext.createAnalyser();
        analyser.fftSize = 1024;
        analyser.smoothingTimeConstant = 0.4;
        audioSource.connect(analyser);
        const volumes = new Uint8Array(analyser.frequencyBinCount);

        this.requestAudioLevels = setInterval(() => {
          analyser.getByteFrequencyData(volumes);
          let volumeSum = 0;
          for (const volume of volumes) {
            volumeSum += volume;
          }
          const averageVolume = Math.round(volumeSum / volumes.length);
          this.colorPids(averageVolume);
        }, 100);
        $("#submit_take_seat").removeClass('disabled');
        if (!isScreenShare) {
          $("#submit_take_seat").trigger('click');
        }

      }).catch(err => {
        console.log(err);
        this.hideLoading()
        $("#submit_take_seat").addClass('disabled');
        this.alert('error', $trans('error-camera-start'), { dataLang: 'error-camera-start' });
        this.showSelfCheckModal();
      });
  }

  replaceAudioTrack(mediaStream, newAudioStream) {
    // Remove all current audio tracks from mediaStream
    mediaStream.getAudioTracks().forEach(track => {
      mediaStream.removeTrack(track);
    });

    // Add the new audio track to mediaStream
    const newAudioTrack = newAudioStream.getAudioTracks()[0];
    mediaStream.addTrack(newAudioTrack);
  }

  onNewDeviceSettingsTestStream = (stream) => {
    //new webrtc myVideo player holder
    this.hideMediaDevices && this.getMediaDevices();
    // if (this.cameraStream) {
    //   this.killStream(this.cameraStream);
    // }
    // this.getCameraHTMLObject().srcObject = stream;

    //inform socket users about resolution from users camera
    const settings = stream.getVideoTracks()[0].getSettings();
    const { width, height } = settings;
    const videosInfo = { camera: { width, height } };
    this.videosInfo = videosInfo;
    this.socket.userStartedWebRTCStream(videosInfo);

    this.hideLoading()

    if (!this.activePreviewVideoModal) {
      this.endTestStream();
      return;
    }

    // $('.video-indicator').each(function (index, el) {
    //   el.srcObject = stream; //TODO listen when loaded
    //
    // });
    // $('#myVideo2').each(function (index, el) {
    //   el.srcObject = stream; //TODO listen when loaded
    // });
    // $('#own-video-call').each(function (index, el) {
    //   el.srcObject = stream; //TODO listen when loaded
    // });
    // $('#myVideoForScreenShare').each(function (index, el) {
    //   el.srcObject = stream; //TODO listen when loaded
    // });
    // if ($('#chess-player-video').length) {
    //   ///this is single element
    //   $('#chess-player-video')[0].srcObject = stream;
    // }
    // if (this.tourIsRunning()) {
    //   $('#myTourVideo').each(function (index, el) {
    //     el.srcObject = stream; //TODO listen when loaded
    //
    //     // if (screenSharingTrack) {
    //     //   (screenSharingTrack = stream.getVideoTracks()[0]);
    //     // }
    //   });
    // }

    // Apply stream settings
    if (this.tourModeController && this.tourModeController.publishStreamId) {
      if (this.view.deviceSettingsMenu.selected.microphone.value) {
        this.tourModeController.webRTCAdaptor.switchAudioInputSource(this.tourModeController.publishStreamId, this.view.deviceSettingsMenu.selected.microphone.value)
      }
      if (this.view.deviceSettingsMenu.selected.camera.value) {
        this.tourModeController.webRTCAdaptor.switchVideoCameraCapture(this.tourModeController.publishStreamId, this.view.deviceSettingsMenu.selected.camera.value)
      }
    }
    this.dispatchEvent({
      type: SCENE_EVENTS.DEVICE_SETTINGS_CHANGED,
      data: {
        camera: this.view.deviceSettingsMenu.selected.camera.value,
        microphone: this.view.deviceSettingsMenu.selected.microphone.value
      }
    })

    $("#submit_take_seat").removeClass('disabled');
  }
  /**
   * TEST INDICATORS FOR STREAM CONFIG
   */
  testStreamTourGuide = async () => {
    const self = this;
    // await this.testifStoredDevices();
    let audio = $(".microphoneSelect").val();
    let video = $(".cameraSelect").val();
    let soundDevice = $(".speakerSelect").val();
    this.showLoading()
    $("#submit_take_seat").addClass('disabled');

    await this.endTestStream();

    this.selectedVideoFromDropDown = video;
    this.selectedAudioFromDropDown = audio;
    // webrtc.switchVideo(video);
    // webrtc.switchAudio(audio);

    navigator.mediaDevices.getUserMedia({ video: true, audio: true })
      .then(stream => {

        this.hideMediaDevices && this.getMediaDevices();
        const settings = stream.getVideoTracks()[0].getSettings();
        const { width, height } = settings;
        const videosInfo = { camera: { width, height } };
        this.videosInfo = videosInfo;
        this.socket.userStartedWebRTCStream(videosInfo);

        this.hideLoading()

        $('#myTourVideo').each(function (index, el) {
          el.srcObject = stream; //TODO listen when loaded
          // if (screenSharingTrack) {
          //   (screenSharingTrack = stream.getVideoTracks()[0]);
          // }
        });
        if (this.tourModeController && this.tourModeController.publishStreamId) {
          this.tourModeController.webRTCAdaptor.switchVideoCameraCapture(this.tourModeController.publishStreamId, $("#settings_camera").val())
          this.tourModeController.webRTCAdaptor.switchAudioInputSource(this.tourModeController.publishStreamId, $("#settings_microphone").val())
        }
        const audioContext = new AudioContext();
        const audioSource = audioContext.createMediaStreamSource(stream);
        const analyser = audioContext.createAnalyser();
        analyser.fftSize = 1024;
        analyser.smoothingTimeConstant = 0.4;
        audioSource.connect(analyser);
        const volumes = new Uint8Array(analyser.frequencyBinCount);

        this.requestAudioLevels = setInterval(() => {
          analyser.getByteFrequencyData(volumes);
          let volumeSum = 0;
          for (const volume of volumes) {
            volumeSum += volume;
          }
          const averageVolume = Math.round(volumeSum / volumes.length);
          this.colorPids(averageVolume);
        }, 100);
      }).catch(err => {
        console.log(err);
        this.hideLoading()
        $("#submit_take_seat").addClass('disabled');
        this.alert('error', $trans('error-camera-start'), { dataLang: 'error-camera-start' });
        this.showSelfCheckModal();
      });
  }
  /**
   * TESTSCREEN SHARE
   */
  testScreenShareStream = async () => {
    var self = this;
    return new Promise(function (resolve, reject) {
      navigator.mediaDevices.getDisplayMedia({
        video: {
          cursor: "always"
        }, audio: {
          echoCancellation: true,
          noiseSuppression: true
        }
      }).then(stream => {
        const screenShare = this.getScreenShareHTMLObject().srcObject = stream;
        screenShare.srcObject = stream;
        self.screenShareStream = stream;
        resolve(stream);
        //webrtc.webRTCAdaptor.mediaManager.localStream.addTrack(videoTrack)
      }).catch(err => {
        console.log(err);
        this.hideLoading()
        $("#submit_take_seat").addClass('disabled');
        this.alert('error', $trans('error-camera-start'), { dataLang: 'error-camera-start' });
        this.showSelfCheckModal();
      });
    });
  }
  /**
   * TESTSCREEN SHARE
   */
  testScreenShareCameraStream = async () => {
    var self = this;
    let audio = $(".microphoneSelect").val();
    let video = $(".cameraSelect").val();
    let soundDevice = $(".speakerSelect").val();
    return new Promise(function (resolve, reject) {
      navigator.mediaDevices.getUserMedia({
        video: { deviceId: { exact: video } },
        audio: { deviceId: { exact: audio }, echoCancellation: true },
      }).then(stream => {
        // const screenShare = self.getScreenShareHTMLObject = stream;
        // screenShare.srcObject = stream;
        const videoEl = document.querySelector('.video-indicator');
        if (videoEl) {
          videoEl.srcObject = stream;
        }
        self.screenShareStream = stream;
        resolve(stream)
        //webrtc.webRTCAdaptor.mediaManager.localStream.addTrack(videoTrack)
      })
    });
  }

  killStream(stream) {
    if (stream) {
      const tracks = stream.getTracks();
      tracks.forEach((track) => {
        track.stop();
      });
      // stream = null;
    }
  }
  muteStream(stream) {
    const audioTracks = stream.getAudioTracks();
    // Mute all audio tracks in the MediaStream
    audioTracks.forEach(track => {
      track.enabled = false;
    });
  }

  unMuteStream(stream) {
    const audioTracks = stream.getAudioTracks();
    // Mute all audio tracks in the MediaStream
    audioTracks.forEach(track => {
      track.enabled = true;
    });
  }

  colorPids = (vol) => {
    let settings_pids = $('.settings-pids .pid');
    let take_seat_pids = $('.take-seat-pids .pid');

    let amout_of_pids = Math.round(vol / 10);
    let elem_range = settings_pids.slice(0, amout_of_pids);
    let elem_range2 = take_seat_pids.slice(0, amout_of_pids);

    for (let i = 0; i < settings_pids.length; i++) {
      settings_pids[i].style.backgroundColor = "#e6e7e8";
      take_seat_pids[i].style.backgroundColor = "#e6e7e8";
    }
    for (let i = 0; i < elem_range.length; i++) {
      elem_range[i].style.backgroundColor = "#69ce2b";
      elem_range2[i].style.backgroundColor = "#69ce2b";
    }
  }

  endTestStream = () => {
    this.requestAudioLevels && clearInterval(this.requestAudioLevels);
    if (this.localTestStream) {
      const pids = $('.pid');
      for (let i = 0; i < pids.length; i++) {
        pids[i].style.backgroundColor = "#e6e7e8";
      }
      this.localTestStream && this.localTestStream.getTracks().forEach((track) => {
        track.stop();
      });
      this.localTestStream = null;
      $(".video-indicator").each(el => $(".video-indicator").eq(el).get(0).srcObject = null);
      const myVideo = $("#myVideo2")[0];
      if (myVideo && myVideo.srcObject) {
        myVideo.srcObject.getAudioTracks().forEach(track => track.enabled = false);
      }
    }
  }

  setSocket = (socket) => {
    this.socket = socket;
    this.dispatchEvent(MODEL_EVENTS.SOCKET_READY);
  }

  uploadAudio(dom_element, clickable, temp_url, url, callbackFunction) {

    const methodController = {
      getBaseUrl: () => (''),
      getMaxFileUploadInMb: () => (3000), //123456792929; //TODO //123456792.929GB ???
      isEasyEditEnabled: () => (true)
    };

    const rest = new aptis.RestCommunicator();
    const fileDragDropUploadController = new aptis.wbt.easyEdit2.FileDragDropUploadController(methodController);

    fileDragDropUploadController.initController(dom_element, clickable, 'audio/*', temp_url,
      //successHandler
      (fileNameOnServer, dropElement, originalFileName) => {
        const data = { fileNameOnServer };
        rest.postRequest(url, data, (error, result) => {
          error ? console.log(error) : callbackFunction(result.url);
        });
      }
    );
  }

  resetPeerChairOptions() {
    if (this.lastPeerChairIClicked !== null) {
      this.lastPeerChairIClicked.hideUserOptions();
      this.lastPeerChairIClicked = null;
    }
  }

  /**
   * CALCULATE DIMENSIONS FOR VIDEO ELMEMENT INSIDE GRID
   */
  calculateGridDimensions = () => {
    let videoCount = $('#localVideoContainer').find('.video-wrapper').length;

    if ($("#screen-share-video").get(0).srcObject === null) {
      videoCount--;
    }


    $('#own-video').get(0).srcObject = $('#localVideo').get(0).srcObject;
    const { userName } = this.getUserData();
    $("#own-label").text(userName);

    $("#my-own-video-wrapper").toggleClass('hidden', !this.iStream.video);
    // $(".video-wrapper").toggleClass('hidden', !this.myWebcamStreamId);
    $("#my-screen-share-wrapper").toggleClass('hidden', !this.iShareScreen);
    $("#my-own-video-wrapper").removeClass('hide-avatar');
    if (this.iShareScreen && !this.myWebcamStreamId) {
      $("#my-own-video-wrapper").addClass('hide-avatar');
    }
    if (this.iShareScreen) {
      $("#my-screen-share-wrapper").show();
    }

    const gridContainerSizes = document.querySelector("#localVideoContainer").getBoundingClientRect();
    const padding = {
      left: $('#localVideoContainer').css('padding-left').replace('px', '') * 1,
      right: $('#localVideoContainer').css('padding-right').replace('px', '') * 1,
      top: $('#localVideoContainer').css('padding-top').replace('px', '') * 1,
      bottom: $('#localVideoContainer').css('padding-bottom').replace('px', '') * 1
    }
    const width = gridContainerSizes.width - (padding.left + padding.right);
    const height = gridContainerSizes.height - (padding.top + padding.bottom);
    if (!videoCount) return
    let rowsCount = 1;
    let columnsCount = 1;

    while (rowsCount * columnsCount < videoCount) {
      if (width / columnsCount < height / rowsCount) { rowsCount++; } else { columnsCount++; }
    }

    let cellDimension = Math.min(width / columnsCount, height / rowsCount);

    if ($(window).width() > 750) {
      this.applyDimensionToGridVideos(cellDimension - 50);
    } else {
      this.applyDimensionToGridVideos(cellDimension - 4);
    }

  }

  applyDimensionToGridVideos = (dimension, columns = 0, rows = 0) => {
    $("#localVideoContainer .video-wrapper").css({ width: `${dimension}px`, height: `${dimension}px` });
    $("#localVideoContainer video").css({ width: `${dimension}px`, height: `${dimension}px` });
    $("#localVideoContainer img").css({ maxHeight: `${dimension}px` });
  }

  playAudioNotification = async (name) => {
    return;
    if (audioElement.src !== `media/${name}.mp3`) {
      audioElement.src = `media/${name}.mp3`;
    }
    if (name == 'enterSeat') {
      console.log('%c play enterSeat', 'background:orange');
      await this.attachSinkId(audioElement, $(".speakerSelect").val());
    }
    audioElement.currentTime = 0;
    this.userClicked && audioElement.play();
  }

  publicStageExists = () => {
    let exists = false;
    for (const key of Object.keys(this.scenes)) {
      if (this.scenes[key].publicStage) {
        exists = true;
      }
    }
    return exists;
  }
  getIDsOfStreamObjs = () => {
    let result = [];
    if (this.currentScene.hasOwnProperty('objects')) {
      let objects = this.currentScene.objects;
      for (const key of Object.keys(objects)) {
        if (objects[key].type === 'guestSeat') {
          result.push(objects[key].id);
        }
        if (objects[key].type === 'screenStream') {
          result.push(objects[key].id);
        }
      }
    }
    return result;
  }
  getNumberOfStreamObjs = () => {
    let result = 0;
    if (this.currentScene.hasOwnProperty('objects')) {
      let objects = this.currentScene.objects;
      for (const key of Object.keys(objects)) {
        if (objects[key].type === 'guestSeat') {
          result += 1;
        }
        if (objects[key].type === 'screenStream') {
          result += 1;
        }
      }
    }
    return result;
  }


  ifShopElementExists = () => {
    let result = false;
    if (this.currentScene.hasOwnProperty('objects')) {
      let objects = this.currentScene.objects;
      for (const key of Object.keys(objects)) {
        if (objects[key].type === 'shopLink') {
          result = true;
          return result;
        }
      }
    }

    return result;
  }

  /**
   * NOTIFICATIONS SYSTEM
   */

  alert = (classType, text, obj = {}) => {
    if (!notificationSettings.error) {
      return
    }

    const data = { ...obj, classType, text }
    this.dispatchEvent({ type: NOTIFICATION_EVENTS.ALERT, data });
  }

  info = (classType, text, obj = {}) => {
    const data = { ...obj, classType, text }
    this.dispatchEvent({ type: NOTIFICATION_EVENTS.INFO, data });
  }

  removeAllNotifications = () => {
    this.dispatchEvent({ type: NOTIFICATION_EVENTS.REMOVE_ALL });
  }

  confirm = (message, success = null, obj = {}, onCancel = null) => {
    const data = { ...obj, message, success, onCancel }
    this.dispatchEvent({ type: NOTIFICATION_EVENTS.CONFIRM, data });
  }

  prompt = (message, initialValue, success = null, obj = {}) => {
    const data = { ...obj, message, initialValue, success }
    this.dispatchEvent({ type: NOTIFICATION_EVENTS.PROMPT, data });
  }

  promptWithConfirm = (message, initialValue, success = null, obj = {}) => {
    const data = { ...obj, message, initialValue, success }
    this.dispatchEvent({ type: NOTIFICATION_EVENTS.PROMPT_WITH_CONFIRM, data });
  }

  startOneOnOneChat = (userId) => {
    const userData = this.socket.getUsersObject()[userId] || null;
    userData && this.dispatchEvent({ type: SCENE_EVENTS.ONE_ON_ONE_CHAT, item: userData });
  }

  resolveOnlineUser = (userId) => {
    const id = String(userId);
    const listed = this.socket.getAllOnlineUsersObject();
    const match = Object.values(listed).find((user) => user && String(user.userId) === id);
    if (!match) {
      return null;
    }
    return {
      ...match,
      userName: match.userName || match.username || '',
      userAvatarUrl: match.userAvatarUrl || match.avatar_image_url || '',
      socketId: match.socketId || match.socket_id || '',
    };
  }

  startOneOnOneVideoCall = (userId) => {
    const userData = this.resolveOnlineUser(userId);
    if (!userData) {
      this.alert('error', $trans('error-call-friend-offline'));
      return;
    }
    this.dispatchEvent({ type: WEBRTC_EVENTS.WEBRTC_VIDEO_ONE_ON_ONE, data: { item: userData } });
  }

  jumpToUser = (userId) => {
    const userData = this.socket.getUsersObject()[userId] || null;
    userData && this.dispatchEvent({ type: SCENE_INTERACTION.JUMP_TO_USER_EVENT, userData });
  }
  onTourScreenShareType = (type) => {
    this.onTourScreenShare = type;
    this.dispatchEvent({ type: SCENE_INTERACTION.TOUR_TAKE_SEAT });
  }
  onKillTourGuestMode = () => {
    this.dispatchEvent({ type: SCENE_INTERACTION.KILL_GUEST_MODE_SOCKET_REQUEST });
  }

  showUserInfo = ({ data = null, userId = false, eventOrigin = '3Dobject', socketItem }) => {
    if (window.baglessTrack) {
      window.baglessTrack(this.config, "User opened profile info", { data: socketItem })
    }
    const actions = this.socket.getGlobalActions();
    this.userIWantToShowInfo = socketItem;
    const userData = eventOrigin === '3Dobject' ? data : this.socket.getUsersObject()[userId];
    let _data = {};
    if (userData) {
      _data = {
        id: userData.userId || userData.id,
        imageUrl: userData.userAvatarUrl || userData.avatar_image_url,
        userName: userData.userName || userData.username,
      }
    }
    if (socketItem) {
      _data = {
        id: socketItem.userId || socketItem.id,
        imageUrl: socketItem.userAvatarUrl || socketItem.avatar_image_url,
        userName: socketItem.userName || socketItem.username,
      }
    }
    if (data) {
      _data = {
        id: data.userId,
        imageUrl: data.userAvatarUrl || data.avatar_image_url,
        userName: data.userName || data.username,
      }
    }
    const { id, imageUrl, userName } = _data;

    if (socketItem === null || !socketItem) {
      this.alert('error', $trans('error-user-data-not-found'), { dataLang: 'error-user-data-not-found' });
      return;
    }
    const userInTour = !!this.isUserInTour(id);
    $("#peer_jump_to")
      .toggleClass("disabled", userInTour)
      .attr("aria-disabled", userInTour ? "true" : null);
    $(".modal.peer_info_modal .modal-content-scrollable").hide();///in case guset user hide this

    $('.modal.peer_info_modal .close-modal').on('click', () => {
      $(".peer_info_modal").removeClass('is-active');
    });

    $('#peer_info_video span').removeClass("disabled")
    $('#peer_info_video').removeClass("disabled")
    if (!this.socket.isUserOnline(id)) {
      $('#peer_info_video').addClass("disabled")
      $('#peer_info_video span').addClass("disabled")
      $('#peer_info_video').off("click")
    }

    $("#peer_info_avatar").attr('src', imageUrl || '/textures/defaultAvatar.png');
    $("#peer_info_id").val(id);
    $("#peer_info_id").data('event-origin', eventOrigin);

    $(".interests_container").html("");
    // $(".clear_info").html("");
    $("#peer_info_company").html("");
    $(".interests_section").hide();
    $('#peer_is_friend').hide();
    $("#peer_add_as_friend").show();

    if (!socketItem.hasProfile || socketItem.hasProfile == 'false') {
      $(".peer_info_modal article").css('opacity', 0);
      $("#peer_info_position").html("");
      $("#peer_info_company").html("");
      $("#peer_info_username").text(userName);

      if (socketItem.isGuest) {
        $(".modal.peer_info_modal .modal-content-scrollable").hide()
        $("#peer_add_as_friend").addClass("disabled");
        $("#peer_remove_as_friend").hide();
      }
      $(".peer_info_modal").addClass('is-active');
    }
    this.showLoading()
    $(".peer_info_modal article").css('opacity', 1);
    $(".peer_info_modal").addClass('is-active');
    this.hideLoading();

    this.loadAndPopulateUserInfo(id, socketItem);

    if (!actions.chat_1_1) {
      $("#peer_info_chat").off();
      $("#peer_info_chat").addClass("disabled")
      $("#peer_info_chat span").addClass("disabled")
    } else {
      $("#peer_info_chat span").removeClass("disabled")
    }

    if (!actions.videoCall) {
      $("#peer_info_video span").addClass("disabled")
      $("#peer_info_video").addClass("disabled")
      $("#peer_info_video").off();
    } else {
      $("#peer_info_video span").removeClass("disabled")
      $("#peer_info_video").removeClass("disabled")
    }

    this.dispatchEvent({
      type: SCENE_INTERACTION.PEOPLE_INFO_OPENED, data: {
        userId: id,
      }
    })
  }

  loadAndPopulateUserInfo = (id, userData) => {
    if (!userData || userData.isGuest) {
      return;
    }
    this.showLoading();
    $(".modal.peer_info_modal .modal-content-scrollable").show()
    const error = () => {
      this.hideLoading();
      this.alert('error', $trans('error-user-data-not-found'), { dataLang: 'error-user-data-not-found' });
    }
    const callback = (response) => {
      this.hideLoading();
      const { data: { username, birthday, web, city, interests, avatar_image_url, details, subscription } } = response;
      $("#peer_info_avatar").attr('src', avatar_image_url || '/textures/defaultAvatar.png');
      $("#peer_info_birthdate").html(birthday);
      $("#peer_info_interests").html(interests);
      $("#peer_info_web").html(web);
      $("#peer_info_location").html(city);
      $("#peer_info_username").text(username);
      $("#peer_info_bio").text(details);
      $("#peer_info_user_plan").text(subscription?.name || 'Free');

      if (this.isFriend(id)) {
        $("#peer_add_as_friend").hide();
        $("#peer_remove_as_friend").show();
        $('#peer_is_friend').show();
        $("#peer_remove_as_friend").off("click");
        $("#peer_remove_as_friend").on("click", () => {
          this.worldFetcher.removeFriend(id, (response) => {
            this.info('success', `Removed from friends list`);
            this.onFriendRemovedSuccess(response);
            $(".peer_info_modal").removeClass('is-active');
            this.dispatchEvent({
              type: SCENE_INTERACTION.USER_FRIEND_REMOVED, data: {
                userId: id,
              }
            })
          });
        })

      } else {
        $("#peer_add_as_friend").show();
        $("#peer_add_as_friend").removeClass("disabled");
        $("#peer_remove_as_friend").hide();
        $('#peer_is_friend').hide();
        if (this.config.isGuest) {
          $("#peer_add_as_friend").addClass("disabled");
          $("#peer_remove_as_friend").addClass("disabled");
          $("#peer_info_chat").addClass("disabled");
          $("#show-space-info .person_add").addClass("disabled");
          $("#show-space-info .person_add").off("click");
          $("#show-space-info-ai-tokens").hide();
        }

        $("#peer_add_as_friend").off("click");
        $("#peer_add_as_friend").on("click", async () => {
          if (!await this.validatePlanFeature(FEATURE_NAMES.BUDDY_LIST)) {
            return;
          }
          this.worldFetcher.addAsFriend(id, (response) => {
            this.onFriendAddedSuccess(response);
            $(".peer_info_modal").removeClass('is-active');
            this.dispatchEvent({
              type: SCENE_INTERACTION.USER_FRIEND_ADDED, data: {
                userId: id,
              }
            })
          });
        });
      }

      const onlineUser = this.isUserOnline(id);
      if (onlineUser) {
        const name = `${onlineUser.worldName} / ${onlineUser.currentSceneName}`;
        $('#peer_info_room').text(name);
        $('#peer_info_room').show();
      } else {
        $('#peer_info_room').hide();
      }
      const txtMod = this.getUserMood(userData.currentUserMood);
      $('#peer_status_text').text(txtMod.name).removeClass('is-primary is-warning is-danger').addClass(txtMod.color);
    }
    this.worldFetcher.getProfileInfo(id, callback, error);
  }

  getUserMood = (mood) => {
    let txtMod = {
      name: 'Available',
      color: 'is-primary'
    }
    switch (mood) {
      case "2":
        txtMod = {
          name: 'Away',
          color: 'is-warning'
        }
        break;
      case "3":
        txtMod = {
          name: 'Do not disturb',
          color: 'is-danger'
        }
        break;
    }

    return txtMod;
  }

  loadWPDataAndShowUserInfo = ({ wpId }) => {

  }

  onFriendsSet = (friendsObj) => {
    this.friends = friendsObj;
    this.dispatchEvent({ type: SCENE_EVENTS.ON_FRIENDS_SET, friendsObj })
  }
  onFriendAddedSuccess = (response) => {
    if (response && response.data && response.data[0]) {
      const { requestedId, status } = response.data[0];
      socket.getUsersObject()[requestedId]
      const user = this.socket.getUsersObject()[requestedId];
      if (!user) {
        this.info('success', `Added to friends list`);
        this.friendsHelper.refreshFriendsList();
        return;
      }
      if (status === "PENDING") {
        this.info('success', `${user.userName} added to friends list`);
      }
      if (status === "APPROVED") {
        this.info('success', `${user.userName} added to friends list`);
      }
    }
    this.friendsHelper.refreshFriendsList();
  }
  onFriendRemovedSuccess = (response) => {
    if (response && response.data) {
      this.info('success', `Removed from friends list`);
      this.friendsHelper.refreshFriendsList();
      return;
    }
    this.friendsHelper.refreshFriendsList();
  }
  isUserInSameWorld = (sceneId) => {
    return this.scenes[sceneId];
  }
  isFriend = (userId) => {
    return this.friendsMap[userId]
  }
  isSceneLockable = (sceneId) => {
    return this.scenesCanBeLocked[sceneId];
  }
  getCurrentSceneName = () => {
    return this.currentScene.publicName || this.currentScene.name;
  }

  /** Start / home room is the first scene in the space (`scenes[0]`). */
  getStartScene = () => {
    const scenes = this.sceneData?.scenes || [];
    return scenes[0] || null;
  }

  isStartRoom = (scene = this.currentScene) => {
    const start = this.getStartScene();
    return !!(start && scene && String(start.id) === String(scene.id));
  }
  getSceneNameFromId = (id) => {
    if (!id) {
      return ''
    }
    if (id === 'EDITOR') {
      return $trans('editor-text');
    }
    return this.scenes[id]?.publicName || this.scenes[id]?.name || '';
  }
  getUserDataById = (id, callback) => {
    if (this.fetchedUserData[id]) {
      callback && callback(this.fetchedUserData[id])
    } else {
      const cb = (response) => {
        this.fetchedUserData[id] = response;
        callback && callback(response)
      }
      this.worldFetcher.getUserById(id, cb)
    }
  }
  showUserInfoFromFetchedData = (id, callback) => {
    let userId;
    if (userHistory[id] && userHistory[id].hasProfile) {
      userId = userHistory[id].hasProfile;
    }
    if (!userId && this.fetchedUserData[id]) {
      userId = this.fetchedUserData[id].remote_id;
    }
    if (!userId) {
      this.getUserDataById(id, callback)
    } else {
      callback && callback(userId);
    }
  }
  takeSeatConfirmModal = async () => {
    this._localStream = await navigator.mediaDevices.getUserMedia({ video: true, audio: true });
    let video = document.querySelector('video#myVideo');
    video.srcObject = this._localStream;
  }

  buyLocationTicket = (data) => {
    this.worldFetcher.buyLocationTicket(this.config.buyLocationTicketURL, data);
  }
  isMuted(id) {
    let enabled = false;
    const element = document.getElementById(`remoteVideo-${id}`);
    if (element) {
      element.srcObject.getAudioTracks().forEach((track) => {
        enabled = track.enabled;
      });
    }
    return enabled;
  }

  tourIsRunning() {
    return this.tourData && Object.keys(this.tourData).length !== 0;
  }

  iAmInTour() {
    if (!this.tourData) {
      return false;
    }
    const socketId = this.socket.getUserData().socketId;
    for (const tour of Object.values(this.tourData)) {
      if (!tour || !socketId) {
        continue;
      }
      if (tour.owner === socketId) {
        return tour;
      }
      if (tour.users && tour.users.includes(socketId)) {
        return tour;
      }
      if (tour.guests && tour.guests.includes(socketId)) {
        return tour;
      }
      if (tour.podiumUsers && tour.podiumUsers.includes(socketId)) {
        return tour;
      }
      if (tour.streams && tour.streams[socketId]) {
        return tour;
      }
    }
    return false;
  }
  iWasInTour(tourData, myOldSocketId) {
    if (!tourData) {
      return false;
    }
    for (const tour of Object.values(tourData)) {
      if (tour.owner === myOldSocketId) {
        return tour;
      }
      if (tour.users && tour.users.includes(myOldSocketId)) {
        return tour;
      }
      if (tour.guests && tour.guests.includes(myOldSocketId)) {
        return tour;
      }
      if (tour.podiumUsers && tour.podiumUsers.includes(myOldSocketId)) {
        return tour;
      }
      if (tour.invitedUsers && tour.invitedUsers.includes(myOldSocketId)) {
        return tour;
      }
      if (tour.invitedToPodium && tour.invitedToPodium.includes(myOldSocketId)) {
        return tour;
      }
      if (tour.streams && Object.keys(tour.streams).includes(myOldSocketId)) {
        return tour;
      }
    }
    return false;
  }

  isUserInTour(id) {
    const socketId = this.socket?._currentUserData[id]?.socketId;
    if (!socketId) {
      return null;
    }
    if (!this.tourData) {
      return null;
    }
    for (const tour of Object.values(this.tourData)) {
      if (!tour) {
        continue;
      }
      if (tour.owner === socketId) {
        return tour;
      }
      if (tour.users && Array.isArray(tour.users) && tour.users.includes(socketId)) {
        return tour;
      }
      if (tour.guests && Array.isArray(tour.guests) && tour.users.includes(socketId)) {
        return tour;
      }
      if (tour.podiumUsers && Array.isArray(tour.podiumUsers) && tour.users.includes(socketId)) {
        return tour;
      }
      if (tour.invitedUsers && Array.isArray(tour.invitedUsers) && tour.users.includes(socketId)) {
        return tour;
      }
      if (tour.invitedToPodium && Array.isArray(tour.invitedToPodium) && tour.users.includes(socketId)) {
        return tour;
      }
    }
    return null;
  }
  findTourByOwner(ownerId) {
    for (const tour of Object.values(this.tourData)) {
      if (!tour) {
        continue;
      }
      if (tour.owner === ownerId) {
        return tour;
      }
    }
    return null;
  }
  iAmGuide() {
    const tour = this.findTourByOwner(this.socket.getUserData().socketId);
    if (!tour) {
      return false;
    }
    if (tour.owner === this.socket.getUserData().socketId) {
      return tour
    }
    return false;
  }
  canRunTour() {
    return (this.sceneData.tourModeAvailable !== 0) && (this.userIsOwner || this.userIsContributor);
  }
  hasStartedTours() {
    return this.tourData && Object.keys(this.tourData).length !== 0;
  }

  isUserOnline(id) {
    let user = null;
    console.log(id)
    if (this.friends && this.friends.online) {
      user = [...this.socket.getUsers(), ...this.friends.online].find((user) => String(user.userId) === String(id));
    }
    return user
  }

  isUserAway(id) {
    let user = this.isUserOnline(id);
    if (user?.currentUserMood != 2) {
      return null;
    }
    return user
  }

  isUserBusy(id) {
    let user = this.isUserOnline(id);
    if (user?.currentUserMood != 3) {
      return null;
    }
    return user
  }

  notAvailableInTourMode() {
    if (this.iAmGuide() || this.guide) {
      return false
    }
    if (this.iAmInTour()) {
      return true
    }
    return false;
  }
  getActiveVapiChair() {
    const chairs = this.view?.vraiAgentChairs || [];
    const withTrackedSession = chairs.find((chair) => chair?.hasActiveVapiSession?.());
    if (withTrackedSession) return withTrackedSession;
    const withClient = chairs.find((chair) => chair?._vapiCallActive && chair?._vapi);
    if (withClient) return withClient;
    const connecting = chairs.find((chair) => chair?._vapiConnecting);
    if (connecting) return connecting;
    return chairs.find((chair) => chair?._vapiCallActive) || null;
  }
  isTalkingWithAgent() {
    return !!this.getActiveVapiChair();
  }
  showTalkingWithAgentError() {
    this.alert('error', $trans('error-not-available-while-talking-with-agent'));
  }
  onSocketEventUpdateUI() {
    this.captureOneToOneTour();
    this.keepStoredOneToOneTour();
    this.dispatchEvent({ type: SCENE_EVENTS.UPDATE_TOUR_UI_ON_SOCKET_DATA })
  }
  stampOneToOne(tour) {
    if (!tour) {
      return;
    }
    tour.oneToOne = true;
    tour.isPrivateTour = true;
    tour.allowAudience = false;
    tour.maxPodium = 1;
  }
  markOneToOneTour(tour) {
    if (!tour?.id) {
      return;
    }
    this.stampOneToOne(tour);
    this.oneToOneTourId = tour.id;
    this.pendingOneToOne = false;
  }
  clearOneToOneTour() {
    this.oneToOneTourId = null;
    this.pendingOneToOne = false;
    this.hostingOneToOne = false;
    this.joiningOneToOnePodium = false;
  }
  captureOneToOneTour() {
    if (!this.tourData) {
      return;
    }
    Object.values(this.tourData).forEach((tour) => {
      if (!tour) {
        return;
      }
      const marked = tour.oneToOne || tour.visibility === 'oneToOne' || (tour.allowAudience === false && Number(tour.maxPodium) === 1);
      if (marked) {
        this.markOneToOneTour(tour);
      }
    });
  }
  keepStoredOneToOneTour() {
    if (!this.oneToOneTourId || !this.tourData) {
      return;
    }
    const tour = this.tourData[this.oneToOneTourId];
    if (!tour) {
      return;
    }
    this.stampOneToOne(tour);
  }
  isOneToOneTour(tour) {
    if (!tour) {
      return false;
    }
    if (tour.oneToOne || tour.visibility === 'oneToOne') {
      return true;
    }
    if (tour.allowAudience === false && Number(tour.maxPodium) === 1) {
      return true;
    }
    if (this.oneToOneTourId && tour.id === this.oneToOneTourId) {
      return true;
    }
    if (!this.hostingOneToOne) {
      return false;
    }
    const mySocketId = this.socket?.getUserData?.().socketId;
    return !this.oneToOneTourId || tour.id === this.oneToOneTourId || tour.owner === mySocketId;
  }
  oneToOneSeatOpen(tour) {
    if (!tour) {
      return false;
    }
    // The guide is placed on the podium when the tour starts. That seat is the host, not the guest.
    const ownerId = tour.owner != null ? String(tour.owner) : null;
    const isGuest = (id) => id != null && String(id) !== ownerId;
    const podium = (Array.isArray(tour.podiumUsers) ? tour.podiumUsers : []).filter(isGuest);
    if (podium.length > 0) {
      return false;
    }
    const invited = (Array.isArray(tour.invitedToPodium) ? tour.invitedToPodium : []).filter(isGuest);
    if (invited.length > 0) {
      return false;
    }
    return ![...(this.pendingTourInvitations?.values() || [])].some((kind) => kind === 'podium');
  }
  canEnterOneToOneTour(tour) {
    if (this.joiningOneToOnePodium) {
      return true;
    }
    const mySocketId = this.socket?.getUserData?.().socketId;
    if (!tour || !mySocketId) {
      return false;
    }
    if (tour.owner === mySocketId) {
      return true;
    }
    return [tour.invitedToPodium, tour.podiumUsers, tour.users, tour.guests].some((list) => Array.isArray(list) && list.includes(mySocketId));
  }
  refuseOneToOneJoin(tour) {
    return this.isOneToOneTour(tour) && !this.canEnterOneToOneTour(tour);
  }
  hideAllContextMenusForCameraComponets() {
    this.dispatchEvent({ type: SCENE_EVENTS.HIDE_CAMERA_COMPONENTS_CONTEXT_MENU })
  }
  getMediaConstraints() {
    let data = {};
    if (this.view.deviceSettingsMenu.selected.camera || this.view.deviceSettingsMenu.selected.microphone) {
      let audio_val = this.view.deviceSettingsMenu.selected.microphone ? this.view.deviceSettingsMenu.selected.microphone.value : undefined;
      let video_val = this.view.deviceSettingsMenu.selected.camera.value ? this.view.deviceSettingsMenu.selected.camera.value : undefined;
      data = {
        video: {
          deviceId: { exact: video_val },
          width: { ideal: 640 },
          height: { ideal: 480 },
          frameRate: { ideal: 30, max: 30 }, // Lower frame rate to reduce load
        },
        audio: {
          deviceId: { exact: audio_val },
          echoCancellation: true,
          noiseSuppression: true,
          autoGainControl: true
        },
      };
      if (audio_val === "default") {
        data.audio = true;
      }
      if (!audio_val) {
        data = {
          ...data,
          audio: true,
        };
      }
      if (!video_val) {
        data = {
          ...data,
          video: {
            width: { ideal: 640 },
            height: { ideal: 480 },
            frameRate: { ideal: 30, max: 30 }, // Lower frame rate to reduce load
          },
        };
      }
    }
    return data;
  }
  setOldDeviceSettingsCameraValue(deviceId) {
    $(".take-seat .cameraSelect option").each((index, select) => {
      $(select).prop('selected', false)
      if ($(select).val() === deviceId) {
        $(select).prop('selected', true);
      }
    });
    this.dispatchEvent({ type: DEVICE_SETTINGS.OLD_DEVICE_SETTINGS_CAMERA_CHANGED })
  }
  isMineTourStream(streamId) {
    return streamId === (this.tourStreamController.screenController.publishStreamId) || (streamId === this.tourStreamController.cameraController.publishStreamId);
  }
  onTakeFirstEmptySeat() {
    this.dispatchEvent({ type: SCENE_INTERACTION.TAKE_FIRST_EMPTY_SEAT })
  }
  showGuestModal(userId) {
    $('#guest-user-modal-content button.primary').removeClass("disabled");
    const socketItem = this.socket.getUsersObject()[userId];
    if (socketItem) {
      const guestUserModal = $("#guestUserModal");
      guestUserModal.find(".guest-user-name-wrapper-left").html(`${socketItem.userName}`)
      guestUserModal.find(".guest-user-name-wrapper-right").html(`${socketItem.userName}`)
      guestUserModal.find(".guest-user-location").html(`${socketItem.worldName}/${socketItem.currentSceneName}`)
      const messageBtn = guestUserModal.find(".confirm-cancel");
      messageBtn.html($trans('send-msg-text'));
      const videoBtn = guestUserModal.find(".confirm-ok");
      videoBtn.html($trans('video-call-text'));
      messageBtn.off();
      videoBtn.off();
      const handlePeopleChatWithUserClicked = (event, item) => {
        guestUserModal.removeClass("is-active");
        this.socket.dispatchEvent({ type: SOCKET_EVENTS.ADD_ONE_ON_ONE_CHAT, data: socketItem });
      }
      const handlePeopleVideoOneOnOneClick = (event, item) => {
        guestUserModal.removeClass("is-active");
        this.dispatchEvent({ type: WEBRTC_EVENTS.WEBRTC_VIDEO_ONE_ON_ONE, data: { item: { ...socketItem } } });
      };

      messageBtn.off("click")
      videoBtn.off("click");

      messageBtn.on("click", handlePeopleChatWithUserClicked)
      videoBtn.on("click", handlePeopleVideoOneOnOneClick)

      if (this.isGuest) {
        messageBtn.hide();
        videoBtn.hide();
      }
      guestUserModal.addClass("is-active");
    }
  }
  showChessMenu() {
    this.dispatchEvent({ type: SCENE_EVENTS.SHOW_CHESS_MENU })
  }

  syncButtonNavUI(showDefault = false) {
    if (this.chessGameMode) {
      OwnChessMenu.show()
      return;
    }

    if (this.activeOneOnOneCall) {
      CallChatControls.show()
      return;
    }

    if (this.isTalkingWithAgent()) {
      OwnVapiMenu.show();
      return;
    }

    if (this.iSitOnThisVRChair) {
      OwnChairMenu.show();
      return;
    }

    const tourStarted = this.iAmInTour();
    if (tourStarted && this.iAmInTour() && showDefault === false) {
      TourControlBar.show()
      return;
    }

    $(`[data-tour-mode-display="1"]`).hide();
    DefaultControlMenu.show()
  }

  closeModal = (delay = 200) => {
    return new Promise((resolve) => {
      this.dispatchEvent({ type: NOTIFICATION_EVENTS.CLOSE });
      setTimeout(() => {
        resolve();
      }, delay);
    });
  };


  getAudioAnalyzerByStreamId(streamId) {
    if (!this.view.filtered3DObjects[SCENE_OBJECT_TYPES.audioAnalyzer]) {
      return null;
    }
    return this.view.filtered3DObjects[SCENE_OBJECT_TYPES.audioAnalyzer].find(item => item.stream?.id === streamId);
  }

  registerAudioAnalyzer(analyzer) {
    if (!this.view.filtered3DObjects[SCENE_OBJECT_TYPES.audioAnalyzer]) {
      this.view.filtered3DObjects[SCENE_OBJECT_TYPES.audioAnalyzer] = [];
    }
    this.view.filtered3DObjects[SCENE_OBJECT_TYPES.audioAnalyzer].push(analyzer);
  }

  removeAudioAnalyzer(analyzer) {
    if (!this.view.filtered3DObjects[SCENE_OBJECT_TYPES.audioAnalyzer]) {
      return
    }
    if (analyzer.videoElement) {
      $(analyzer.videoElement)
        .data('volumeAnalyser', null)
        .data('pollingStarted', false);
    }
    this.view.filtered3DObjects[SCENE_OBJECT_TYPES.audioAnalyzer] = this.view.filtered3DObjects[SCENE_OBJECT_TYPES.audioAnalyzer].filter(item => item !== analyzer);
  }
  forceQuitChessGame() {
    this.dispatchEvent({ type: SCENE_EVENTS.FORCE_QUIT_CHESS_GAME })
  }

  isUserInChessRoom(userId) {
    for (const gameId in this.socket.chessGames) {
      if (this.socket.chessGames[gameId]?.visitors?.[userId] || this.socket.chessGames[gameId]?.players?.[userId]) {
        return { chessGame: this.socket.chessGames[gameId], gameId: gameId };
      }
    }
    return false
  }

  isUserPlayingChess(userId) {
    for (const gameId in this.socket.chessGames) {
      if (this.socket.chessGames[gameId]?.takenSeats?.player1 === userId || this.socket.chessGames[gameId]?.takenSeats?.player2 === userId) {
        return { chessGame: this.socket.chessGames[gameId], gameId: gameId };
      }
    }
    return false;
  }
  isUserVisitorInChessGame(userId) {
    for (const gameId in this.socket.chessGames) {
      const takenSeats = this.socket.chessGames[gameId]?.takenSeats;
      if (!takenSeats) { continue; }
      for (const seatKey of Object.keys(takenSeats)) {
        if (seatKey.startsWith("player-indicator-visitor-") && takenSeats[seatKey] === userId) {
          return { chessGame: this.socket.chessGames[gameId], gameId: gameId };
        }
      }
    }
    return false;
  }

  async validatePlanFeature(featureName) {
    let subscribedFeature = this.config?.subscriptionPlan?.plan?.features?.[featureName]
    if (!subscribedFeature) {
      subscribedFeature = await checkUserFeature(featureName)
    }
    if (!subscribedFeature.availability) {
      if (this.config.isGuest) {
        this.alert('error', $trans('error-not-available-in-guest-plan'));
      } else {
        this.alert('error', $trans('error-not-available-in-current-plan'));
      }
      return false;
    }

    return true;
  }
  openChessModal(chessGame, userId) {
    this.dispatchEvent({ type: SCENE_EVENTS.OPEN_CHESS_MODAL, data: { ...chessGame, userId } });
  }
  reloadPostits() {
    this.dispatchEvent({ type: SCENE_EVENTS.RELOAD_POSTITS })
  }
  createAndOpenChat(user) {
    this.socket.dispatchEvent({
      type: SOCKET_EVENTS.ADD_ONE_ON_ONE_CHAT,
      data: user,
    });
  }
  navbarItemClicked() {
    this.dispatchEvent({ type: SCENE_EVENTS.NAVBAR_ITEM_CLICKED })
  }
}

export { Model }
